(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-metaobjects"] && !Shopify.designMode) return;
  try {
    
  const createHeaderDebounce = (callback, wait = 180) => {
    let timeout;

    return (...args) => {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => callback(...args), wait);
    };
  };

  const HEADER_OVERLAY_MODE_CLASSES = [
    'site-header-overlay--sidebar',
    'site-header-overlay--menu',
    'site-header-overlay--drawer',
    'site-header-overlay--mega',
  ];

  const getHeaderOverlayMode = () => {
    if (document.body.classList.contains('site-header-sidebar-open')) {
      return 'sidebar';
    }

    if (document.querySelector('.site-header__drawer[open]:not(.is-closing)')) {
      return 'drawer';
    }

    if (document.querySelector('.site-header__desktop-disclosure--mega.is-panel-visible')) {
      return 'mega';
    }

    return '';
  };

  const clearHeaderOverlayAnimation = (overlay) => {
    if (overlay._headerOverlayShowFrame) {
      window.cancelAnimationFrame(overlay._headerOverlayShowFrame);
      overlay._headerOverlayShowFrame = null;
    }

    if (overlay._headerOverlayHideTimer) {
      window.clearTimeout(overlay._headerOverlayHideTimer);
      overlay._headerOverlayHideTimer = null;
    }
  };

  const getHeaderOverlayHideDuration = (mode) => {
    if (mode === 'drawer') {
      return 420;
    }

    if (mode === 'mega') {
      return 280;
    }

    return 240;
  };

  const applyHeaderOverlayMode = (overlay, mode) => {
    overlay.classList.remove(...HEADER_OVERLAY_MODE_CLASSES);

    if (mode === 'sidebar') {
      overlay.classList.add('site-header-overlay--sidebar');
    } else if (mode === 'drawer') {
      overlay.classList.add('site-header-overlay--menu', 'site-header-overlay--drawer');
    } else if (mode === 'mega') {
      overlay.classList.add('site-header-overlay--menu', 'site-header-overlay--mega');
    }

    overlay.dataset.overlayMode = mode;
  };

  const syncHeaderOverlayState = () => {
    const overlay = document.querySelector('[data-header-overlay]');

    if (!overlay) {
      return;
    }

    const nextMode = getHeaderOverlayMode();
    const hasMenuOpen = Boolean(document.querySelector('.site-header__drawer[open]'))
      || Boolean(document.querySelector('.site-header__desktop-disclosure[open]'));

    clearHeaderOverlayAnimation(overlay);
    document.body.classList.toggle('site-header-menu-open', hasMenuOpen);

    if (nextMode === '') {
      if (!overlay.classList.contains('is-visible')) {
        overlay.hidden = true;
        overlay.classList.remove(...HEADER_OVERLAY_MODE_CLASSES);
        overlay.dataset.overlayMode = '';
        return;
      }

      const currentMode = overlay.dataset.overlayMode || '';
      overlay.classList.remove('is-visible');
      overlay._headerOverlayHideTimer = window.setTimeout(() => {
        overlay.hidden = true;
        overlay.classList.remove(...HEADER_OVERLAY_MODE_CLASSES);
        overlay.dataset.overlayMode = '';
        overlay._headerOverlayHideTimer = null;
      }, getHeaderOverlayHideDuration(currentMode));
      return;
    }

    const modeChanged = overlay.dataset.overlayMode !== nextMode;

    applyHeaderOverlayMode(overlay, nextMode);

    if (overlay.hidden) {
      overlay.hidden = false;
      overlay._headerOverlayShowFrame = window.requestAnimationFrame(() => {
        overlay._headerOverlayShowFrame = window.requestAnimationFrame(() => {
          overlay.classList.add('is-visible');
          overlay._headerOverlayShowFrame = null;
        });
      });
      return;
    }

    if (modeChanged) {
      overlay.offsetHeight;
    }

    overlay.classList.add('is-visible');
  };

  window.AerofoilsSyncHeaderOverlayState = syncHeaderOverlayState;

  const initDesktopHeaderMenus = () => {
    const desktopMedia = window.matchMedia('(min-width: 1025px)');
    const desktopDisclosures = Array.from(document.querySelectorAll('.site-header__desktop-disclosure'));
    const hoverCloseDelay = 200;
    const panelAnimationDuration = 280;

    if (!desktopDisclosures.length) {
      return;
    }

    const clearCloseTimer = (disclosure) => {
      if (disclosure.headerCloseTimer) {
        window.clearTimeout(disclosure.headerCloseTimer);
        disclosure.headerCloseTimer = null;
      }
    };

    const clearAnimationTimer = (disclosure) => {
      if (disclosure.headerAnimationTimer) {
        window.clearTimeout(disclosure.headerAnimationTimer);
        disclosure.headerAnimationTimer = null;
      }
    };

    const closeDisclosure = (disclosure, options = {}) => {
      const { immediate = false } = options;
      const summary = disclosure.querySelector('summary');
      clearCloseTimer(disclosure);
      disclosure.dataset.openMode = '';
      summary?.setAttribute('aria-expanded', 'false');

      if (!disclosure.open) {
        disclosure.classList.remove('is-panel-visible');
        disclosure.classList.remove('is-panel-closing');
        clearAnimationTimer(disclosure);
        syncHeaderOverlayState();
        return;
      }

      if (!disclosure.classList.contains('site-header__desktop-disclosure--mega') || immediate) {
        clearAnimationTimer(disclosure);
        disclosure.classList.remove('is-panel-visible');
        disclosure.classList.remove('is-panel-closing');
        disclosure.open = false;
        syncHeaderOverlayState();
        return;
      }

      clearAnimationTimer(disclosure);
      disclosure.classList.remove('is-panel-visible');
      disclosure.classList.add('is-panel-closing');
      syncHeaderOverlayState();
      disclosure.headerAnimationTimer = window.setTimeout(() => {
        disclosure.open = false;
        disclosure.classList.remove('is-panel-closing');
        disclosure.headerAnimationTimer = null;
        syncHeaderOverlayState();
      }, panelAnimationDuration);
    };

    const closeAllDisclosures = (exceptDisclosure = null, options = {}) => {
      document.querySelectorAll('.site-header__desktop-disclosure').forEach((disclosure) => {
        if (disclosure !== exceptDisclosure) {
          closeDisclosure(disclosure, options);
        }
      });
    };

    const openDisclosure = (disclosure, mode) => {
      if (!desktopMedia.matches) {
        return;
      }

      const summary = disclosure.querySelector('summary');
      clearCloseTimer(disclosure);
      clearAnimationTimer(disclosure);
      closeAllDisclosures(disclosure);
      disclosure.classList.remove('is-panel-closing');

      if (!disclosure.open) {
        disclosure.open = true;
      }

      disclosure.dataset.openMode = mode;
      summary?.setAttribute('aria-expanded', 'true');

      if (disclosure.classList.contains('site-header__desktop-disclosure--mega')) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            disclosure.classList.add('is-panel-visible');
            syncHeaderOverlayState();
          });
        });
      }
    };

    const scheduleCloseDisclosure = (disclosure) => {
      clearCloseTimer(disclosure);
      disclosure.headerCloseTimer = window.setTimeout(() => {
        closeDisclosure(disclosure);
      }, hoverCloseDelay);
    };

    const toggleDisclosure = (disclosure) => {
      if (disclosure.open && disclosure.dataset.openMode === 'click') {
        closeDisclosure(disclosure);
        return;
      }

      openDisclosure(disclosure, 'click');
    };

    desktopDisclosures.forEach((disclosure) => {
      if (disclosure.dataset.desktopMenuReady === 'true') {
        return;
      }

      const summary = disclosure.querySelector('summary');
      if (!summary) {
        return;
      }

      disclosure.dataset.desktopMenuReady = 'true';
      summary.setAttribute('aria-expanded', disclosure.hasAttribute('open') ? 'true' : 'false');
      disclosure.classList.toggle('is-panel-visible', disclosure.hasAttribute('open'));

      summary.addEventListener('click', (event) => {
        if (!desktopMedia.matches) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        toggleDisclosure(disclosure);
      });

      disclosure.addEventListener('mouseenter', () => {
        if (!desktopMedia.matches || disclosure.dataset.openMode === 'click') {
          return;
        }

        clearCloseTimer(disclosure);
        openDisclosure(disclosure, 'hover');
      });

      disclosure.addEventListener('mouseleave', () => {
        if (!desktopMedia.matches || disclosure.dataset.openMode === 'click') {
          return;
        }

        scheduleCloseDisclosure(disclosure);
      });
    });

    if (window.AerofoilsHeaderDesktopMenusBound) {
      return;
    }

    window.AerofoilsHeaderDesktopMenusBound = true;
    window.AerofoilsCloseDesktopMegaMenus = (options = {}) => {
      closeAllDisclosures(null, options);
    };

    document.addEventListener('click', (event) => {
      if (!desktopMedia.matches) {
        return;
      }

      document.querySelectorAll('.site-header__desktop-disclosure').forEach((disclosure) => {
        if (disclosure.dataset.openMode === 'click' && !disclosure.contains(event.target)) {
          closeDisclosure(disclosure);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllDisclosures();
      }
    });

    const handleBreakpointChange = (mediaQuery) => {
      if (!mediaQuery.matches) {
        closeAllDisclosures(null, { immediate: true });
      }
    };

    if (typeof desktopMedia.addEventListener === 'function') {
      desktopMedia.addEventListener('change', handleBreakpointChange);
    } else if (typeof desktopMedia.addListener === 'function') {
      desktopMedia.addListener(handleBreakpointChange);
    }

    syncHeaderOverlayState();
  };

  initDesktopHeaderMenus();

  if (!window.AerofoilsHeaderDesktopMenusSectionLoadBound) {
    document.addEventListener('shopify:section:load', initDesktopHeaderMenus);
    window.AerofoilsHeaderDesktopMenusSectionLoadBound = true;
  }

  const initShopMegaMenus = () => {
    document.querySelectorAll('[data-shop-mega]').forEach((menu) => {
      if (menu.dataset.shopMegaReady === 'true') {
        return;
      }

      const triggers = Array.from(menu.querySelectorAll('[data-shop-nav-trigger]'));
      const stages = Array.from(menu.querySelectorAll('[data-shop-stage]'));

      if (!stages.length) {
        return;
      }

      menu.dataset.shopMegaReady = 'true';

      const activateStage = (requestedKey = 'default') => {
        const activeKey = requestedKey || 'default';

        triggers.forEach((trigger) => {
          trigger.classList.toggle('is-active', trigger.dataset.shopNavTrigger === activeKey);
        });

        stages.forEach((stage) => {
          stage.classList.toggle('is-active', stage.dataset.shopStage === activeKey);
        });
      };

      activateStage('default');

      triggers.forEach((trigger) => {
        const stageKey = trigger.dataset.shopNavTrigger || 'default';

        trigger.addEventListener('mouseenter', () => {
          activateStage(stageKey);
        });

        trigger.addEventListener('focus', () => {
          activateStage(stageKey);
        });

        trigger.addEventListener('click', () => {
          activateStage(stageKey);
        });
      });

      menu.addEventListener('mouseleave', () => {
        activateStage('default');
      });

      menu.addEventListener('toggle', () => {
        if (!menu.open) {
          activateStage('default');
        }
      });
    });
  };

  initShopMegaMenus();

  if (!window.AerofoilsShopMegaMenusBound) {
    document.addEventListener('shopify:section:load', initShopMegaMenus);
    window.AerofoilsShopMegaMenusBound = true;
  }

  const initEfoilsMegaMenus = () => {
    document.querySelectorAll('[data-efoils-mega]').forEach((menu) => {
      if (menu.dataset.efoilsMegaReady === 'true') {
        return;
      }

      const triggers = Array.from(menu.querySelectorAll('[data-efoils-nav-trigger]'));
      const banners = Array.from(menu.querySelectorAll('[data-efoils-banner]'));

      if (!triggers.length || !banners.length) {
        return;
      }

      menu.dataset.efoilsMegaReady = 'true';

      const fallbackKey = triggers[0]?.dataset.efoilsNavTrigger || '';

      const activateBanner = (requestedKey) => {
        const activeKey = requestedKey || fallbackKey;

        triggers.forEach((trigger) => {
          trigger.classList.toggle('is-active', trigger.dataset.efoilsNavTrigger === activeKey);
        });

        banners.forEach((banner) => {
          banner.classList.toggle('is-active', banner.dataset.efoilsBanner === activeKey);
        });
      };

      const initialKey =
        triggers.find((trigger) => trigger.classList.contains('is-active'))?.dataset.efoilsNavTrigger ||
        fallbackKey;

      activateBanner(initialKey);

      triggers.forEach((trigger) => {
        const bannerKey = trigger.dataset.efoilsNavTrigger || '';

        trigger.addEventListener('mouseenter', () => {
          activateBanner(bannerKey);
        });

        trigger.addEventListener('focus', () => {
          activateBanner(bannerKey);
        });

        trigger.addEventListener('click', () => {
          activateBanner(bannerKey);
        });
      });
    });
  };

  initEfoilsMegaMenus();

  if (!window.AerofoilsEfoilsMegaMenusBound) {
    document.addEventListener('shopify:section:load', initEfoilsMegaMenus);
    window.AerofoilsEfoilsMegaMenusBound = true;
  }

  const initHeaderMenuDrawerViews = () => {
    document.querySelectorAll('.site-header__drawer').forEach((drawer) => {
      if (drawer.dataset.headerMenuReady === 'true') {
        return;
      }

      drawer.dataset.headerMenuReady = 'true';

      const views = Array.from(drawer.querySelectorAll('[data-header-drawer-view]'));
      const openViewTriggers = Array.from(drawer.querySelectorAll('[data-header-drawer-open]'));
      const backTriggers = Array.from(drawer.querySelectorAll('[data-header-drawer-back]'));
      const closeTriggers = Array.from(drawer.querySelectorAll('[data-header-menu-close]'));
      const shopView = drawer.querySelector('[data-header-drawer-view="shop"]');
      const shopAccordions = Array.from(drawer.querySelectorAll('[data-shop-accordion]'));
      const SHOP_ACCORDION_DURATION = 280;
      const DRAWER_VIEW_DURATION = 360;
      const DRAWER_CLOSE_DURATION = 420;
      const VIEW_TRANSITION_CLASSES = [
        'is-active',
        'is-underlay',
        'is-entering-from-right',
        'is-entering-from-left',
        'is-exiting-to-left',
        'is-exiting-to-right',
      ];
      let activeViewName = 'main';

      const prefersReducedMotion = () =>
        window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const getView = (viewName) =>
        views.find((view) => view.dataset.headerDrawerView === viewName) || null;

      const getShopAccordionParts = (accordion) => ({
        summary: accordion.querySelector('.site-header__shop-accordion-summary'),
        content: accordion.querySelector('.site-header__shop-accordion-content'),
      });

      const resetViewClasses = (view) => {
        view.classList.remove.apply(view.classList, VIEW_TRANSITION_CLASSES);
      };

      const clearDrawerViewAnimation = () => {
        if (drawer._headerDrawerViewAnimationFrame) {
          window.cancelAnimationFrame(drawer._headerDrawerViewAnimationFrame);
          drawer._headerDrawerViewAnimationFrame = null;
        }

        if (drawer._headerDrawerViewTimer) {
          window.clearTimeout(drawer._headerDrawerViewTimer);
          drawer._headerDrawerViewTimer = null;
        }

        drawer.classList.remove('is-drawer-view-transitioning');
      };

      const clearDrawerCloseAnimation = () => {
        if (drawer._headerDrawerCloseTimer) {
          window.clearTimeout(drawer._headerDrawerCloseTimer);
          drawer._headerDrawerCloseTimer = null;
        }

        drawer.classList.remove('is-closing');
      };

      const clearPendingShopReset = () => {
        if (drawer._headerShopResetTimer) {
          window.clearTimeout(drawer._headerShopResetTimer);
          drawer._headerShopResetTimer = null;
        }
      };

      const syncDrawerViewState = (viewName) => {
        clearDrawerViewAnimation();

        views.forEach((view) => {
          const isActive = view.dataset.headerDrawerView === viewName;

          resetViewClasses(view);
          view.hidden = !isActive;
          view.classList.toggle('is-active', isActive);
        });

        activeViewName = viewName;
        drawer.dataset.activeDrawerView = viewName;
      };

      const clearShopAccordionAnimation = (accordion) => {
        const animationState = accordion._shopAccordionAnimation;

        if (!animationState) {
          return;
        }

        window.clearTimeout(animationState.fallbackTimer);
        animationState.content.removeEventListener(
          'transitionend',
          animationState.onTransitionEnd
        );
        accordion._shopAccordionAnimation = null;
      };

      const syncShopAccordionState = (accordion, expanded) => {
        const { summary, content } = getShopAccordionParts(accordion);

        if (!summary || !content) {
          return;
        }

        clearShopAccordionAnimation(accordion);
        accordion.open = expanded;
        accordion.classList.remove('is-opening', 'is-closing');
        accordion.dataset.shopAccordionAnimating = 'false';
        summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        content.setAttribute('aria-hidden', expanded ? 'false' : 'true');
        content.style.height = expanded ? 'auto' : '0px';
      };

      const syncShopDrawerState = () => {
        if (!shopView) {
          return;
        }

        const hasOpenAccordion = shopAccordions.some((accordion) => accordion.open);
        shopView.classList.toggle('has-open-accordion', hasOpenAccordion);
      };

      const resetShopDrawerState = () => {
        clearPendingShopReset();

        shopAccordions.forEach((accordion) => {
          syncShopAccordionState(accordion, false);
        });
        syncShopDrawerState();
      };

      const animateShopAccordion = (accordion, expanded) => {
        const { summary, content } = getShopAccordionParts(accordion);

        if (!summary || !content) {
          return;
        }

        if (prefersReducedMotion()) {
          syncShopAccordionState(accordion, expanded);
          syncShopDrawerState();
          return;
        }

        clearShopAccordionAnimation(accordion);

        let isFinished = false;

        const finish = () => {
          if (isFinished) {
            return;
          }

          isFinished = true;
          clearShopAccordionAnimation(accordion);
          accordion.open = expanded;
          accordion.classList.remove('is-opening', 'is-closing');
          accordion.dataset.shopAccordionAnimating = 'false';
          summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          content.setAttribute('aria-hidden', expanded ? 'false' : 'true');
          content.style.height = expanded ? 'auto' : '0px';
          syncShopDrawerState();
        };

        const onTransitionEnd = (event) => {
          if (event.target !== content || event.propertyName !== 'height') {
            return;
          }

          finish();
        };

        accordion.dataset.shopAccordionAnimating = 'true';
        accordion.classList.toggle('is-opening', expanded);
        accordion.classList.toggle('is-closing', !expanded);

        if (expanded) {
          const startHeight = content.getBoundingClientRect().height;

          accordion.open = true;
          summary.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
          content.style.height = `${startHeight}px`;
          content.offsetHeight;

          const targetHeight = content.scrollHeight;

          accordion._shopAccordionAnimation = {
            content,
            onTransitionEnd,
            fallbackTimer: window.setTimeout(
              finish,
              SHOP_ACCORDION_DURATION + 80
            ),
          };

          content.addEventListener('transitionend', onTransitionEnd);
          syncShopDrawerState();

          window.requestAnimationFrame(() => {
            content.style.height = `${targetHeight}px`;
          });

          return;
        }

        const startHeight = content.getBoundingClientRect().height || content.scrollHeight;

        content.style.height = `${startHeight}px`;
        content.offsetHeight;
        accordion._shopAccordionAnimation = {
          content,
          onTransitionEnd,
          fallbackTimer: window.setTimeout(finish, SHOP_ACCORDION_DURATION + 80),
        };

        content.addEventListener('transitionend', onTransitionEnd);

        window.requestAnimationFrame(() => {
          content.style.height = '0px';
        });
      };

      const animateDrawerView = (viewName, direction) => {
        const currentView = getView(activeViewName) || getView('main');
        const nextView = getView(viewName);

        if (!currentView || !nextView || currentView === nextView) {
          syncDrawerViewState(viewName);
          return;
        }

        clearDrawerViewAnimation();
        drawer.classList.add('is-drawer-view-transitioning');

        views.forEach((view) => {
          resetViewClasses(view);
        });

        currentView.hidden = false;
        nextView.hidden = false;
        currentView.classList.add('is-active');
        nextView.classList.add('is-active');

        if (direction === 'back') {
          nextView.classList.add('is-underlay', 'is-entering-from-left');

          drawer._headerDrawerViewAnimationFrame = window.requestAnimationFrame(() => {
            drawer._headerDrawerViewAnimationFrame = window.requestAnimationFrame(() => {
              nextView.classList.remove('is-entering-from-left');
              currentView.classList.add('is-exiting-to-right');
            });
          });
        } else {
          currentView.classList.add('is-underlay');
          nextView.classList.add('is-entering-from-right');

          drawer._headerDrawerViewAnimationFrame = window.requestAnimationFrame(() => {
            drawer._headerDrawerViewAnimationFrame = window.requestAnimationFrame(() => {
              currentView.classList.add('is-exiting-to-left');
              nextView.classList.remove('is-entering-from-right');
            });
          });
        }

        drawer._headerDrawerViewTimer = window.setTimeout(() => {
          syncDrawerViewState(viewName);
        }, DRAWER_VIEW_DURATION + 60);
      };

      const showView = (viewName, options = {}) => {
        const immediate = options.immediate === true;
        const direction = options.direction || (viewName === 'main' ? 'back' : 'forward');

        if (immediate || !drawer.open || prefersReducedMotion()) {
          syncDrawerViewState(viewName);
          return;
        }

        animateDrawerView(viewName, direction);
      };

      const closeDrawer = () => {
        if (!drawer.open || drawer.classList.contains('is-closing')) {
          return;
        }

        if (prefersReducedMotion()) {
          drawer.removeAttribute('open');
          syncHeaderOverlayState();
          return;
        }

        clearDrawerCloseAnimation();
        drawer.classList.add('is-closing');
        syncHeaderOverlayState();
        drawer._headerDrawerCloseTimer = window.setTimeout(() => {
          drawer.removeAttribute('open');
        }, DRAWER_CLOSE_DURATION);
      };

      drawer.aerofoilsCloseMenu = closeDrawer;

      showView('main', { immediate: true });
      syncShopDrawerState();

      shopAccordions.forEach((accordion) => {
        const { summary } = getShopAccordionParts(accordion);

        if (!summary) {
          return;
        }

        syncShopAccordionState(accordion, accordion.open);

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          const shouldExpand = !accordion.open;

          if (shouldExpand) {
            shopAccordions.forEach((otherAccordion) => {
              if (otherAccordion !== accordion && otherAccordion.open) {
                animateShopAccordion(otherAccordion, false);
              }
            });
          }

          animateShopAccordion(accordion, shouldExpand);
        });
      });

      openViewTriggers.forEach((trigger) => {
        const viewName = trigger.dataset.headerDrawerOpen || 'main';

        trigger.addEventListener('click', (event) => {
          event.preventDefault();

          if (viewName !== 'shop') {
            resetShopDrawerState();
          }

          showView(viewName, { direction: 'forward' });
        });
      });

      backTriggers.forEach((trigger) => {
        const viewName = trigger.dataset.headerDrawerBack || 'main';

        trigger.addEventListener('click', (event) => {
          event.preventDefault();

          if (activeViewName === 'shop' && viewName === 'main' && !prefersReducedMotion()) {
            clearPendingShopReset();
            drawer._headerShopResetTimer = window.setTimeout(() => {
              resetShopDrawerState();
            }, DRAWER_VIEW_DURATION + 60);
          } else {
            resetShopDrawerState();
          }

          showView(viewName, { direction: 'back' });
        });
      });

      closeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          closeDrawer();
        });
      });

      drawer.addEventListener('toggle', () => {
        clearDrawerCloseAnimation();

        if (drawer.open) {
          showView('main', { immediate: true });
          syncShopDrawerState();
          syncHeaderOverlayState();
          return;
        }

        clearDrawerViewAnimation();
        resetShopDrawerState();
        showView('main', { immediate: true });
        syncHeaderOverlayState();
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
          return;
        }

        if (drawer.classList.contains('is-closing')) {
          event.preventDefault();
          return;
        }

        if (!drawer.open) {
          return;
        }

        event.preventDefault();
        closeDrawer();
      });
    });
  };

  initHeaderMenuDrawerViews();

  if (!window.AerofoilsHeaderMenuDrawerViewsBound) {
    document.addEventListener('shopify:section:load', initHeaderMenuDrawerViews);
    window.AerofoilsHeaderMenuDrawerViewsBound = true;
  }

  const isHeaderInteractionOpen = () =>
    document.body.classList.contains('site-header-sidebar-open') ||
    Boolean(document.querySelector('.site-header__drawer[open]')) ||
    Boolean(document.querySelector('.site-header__desktop-disclosure[open]'));

  const initHeaderRevealOnScroll = () => {
    const header = document.querySelector('.site-header');

    if (!header) {
      return;
    }

    if (!window.AerofoilsHeaderScrollReveal) {
      let lastScrollY = window.scrollY;
      let ticking = false;
      const scrollThreshold = 12;
      const topOffset = 24;

      const sync = () => {
        const currentHeader = document.querySelector('.site-header');

        if (!currentHeader) {
          ticking = false;
          return;
        }

        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > lastScrollY;
        const scrollDelta = Math.abs(currentScrollY - lastScrollY);

        if (currentScrollY <= topOffset || isHeaderInteractionOpen()) {
          currentHeader.classList.remove('is-scroll-hidden');
          lastScrollY = currentScrollY;
          ticking = false;
          return;
        }

        if (scrollDelta >= scrollThreshold) {
          currentHeader.classList.toggle('is-scroll-hidden', scrollingDown);
          lastScrollY = currentScrollY;
        }

        ticking = false;
      };

      const onScroll = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        window.requestAnimationFrame(sync);
      };

      const revealIfNeeded = () => {
        const currentHeader = document.querySelector('.site-header');

        if (currentHeader && isHeaderInteractionOpen()) {
          currentHeader.classList.remove('is-scroll-hidden');
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('click', revealIfNeeded);

      window.AerofoilsHeaderScrollReveal = {
        revealIfNeeded: revealIfNeeded,
        reset: () => {
          lastScrollY = window.scrollY;
        },
        sync: sync,
      };
    }

    header.classList.remove('is-scroll-hidden');
    window.AerofoilsHeaderScrollReveal.reset();
    window.AerofoilsHeaderScrollReveal.sync();
  };

  initHeaderRevealOnScroll();

  if (!window.AerofoilsHeaderScrollRevealSectionLoadBound) {
    document.addEventListener('shopify:section:load', initHeaderRevealOnScroll);
    window.AerofoilsHeaderScrollRevealSectionLoadBound = true;
  }

  if (!customElements.get('localization-form')) {
    /**
     * Dropdown-Verhalten für den Sprachumschalter.
     *
     * Das Umschalten selbst macht Shopify's natives Localization-Form: jede
     * Option ist ein `<button type="submit" name="locale_code">`. Diese Klasse
     * fügt nur das Auf-/Zuklappen und den Submit-on-change des mobilen Selects
     * hinzu — ohne JS bleibt der Umschalter voll funktionsfähig.
     */
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-localization-button]');
        this.panel = this.querySelector('[data-localization-panel]');
        this.nativeSelect = this.querySelector('[data-localization-native-select]');
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleNativeSelectChange = this.handleNativeSelectChange.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
      }

      connectedCallback() {
        if (this.nativeSelect) {
          this.nativeSelect.addEventListener('change', this.handleNativeSelectChange);
        }

        if (!this.button || !this.panel) {
          return;
        }

        this.button.addEventListener('click', this.handleButtonClick);
        document.addEventListener('click', this.handleClickOutside);
        this.addEventListener('keyup', this.handleEscape);
        this.addEventListener('focusout', this.handleFocusOut);
      }

      disconnectedCallback() {
        this.nativeSelect?.removeEventListener('change', this.handleNativeSelectChange);
        this.button?.removeEventListener('click', this.handleButtonClick);
        document.removeEventListener('click', this.handleClickOutside);
        this.removeEventListener('keyup', this.handleEscape);
        this.removeEventListener('focusout', this.handleFocusOut);
      }

      handleButtonClick() {
        this.toggle();
      }

      handleNativeSelectChange(event) {
        event.currentTarget.form?.submit();
      }

      toggle() {
        if (!this.panel) {
          return;
        }

        if (this.panel.hidden) {
          this.open();
        } else {
          this.close();
        }
      }

      open() {
        if (!this.button || !this.panel) {
          return;
        }

        this.button.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
      }

      close() {
        if (!this.button || !this.panel) {
          return;
        }

        this.button.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
      }

      handleClickOutside(event) {
        if (!this.contains(event.target)) {
          this.close();
        }
      }

      handleEscape(event) {
        if (event.key === 'Escape') {
          this.close();
          this.button?.focus();
        }
      }

      handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.close();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  if (!customElements.get('header-search-form')) {
    class HeaderSearchForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.input = this.querySelector('[data-search-input]');
        this.resultsContainer = this.querySelector('[data-search-results]');
        this.searchUrl = this.dataset.searchUrl || '';
        this.loadingLabel = this.dataset.loadingLabel || 'Searching...';
        this.unavailableLabel = this.dataset.unavailableLabel || 'Search is currently unavailable.';
        this.results = [];
        this.activeIndex = -1;
        this.cachedResults = {};
        this.abortController = null;
        this.handleInput = createHeaderDebounce(this.handleInput.bind(this), 180);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        if (!this.form || !this.input || !this.resultsContainer) {
          return;
        }

        this.input.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.input?.removeEventListener('input', this.handleInput);
        this.input?.removeEventListener('keydown', this.handleKeydown);
      }

      async handleInput() {
        const typedQuery = this.input.value.trim();

        if (!typedQuery) {
          this.clearResults();
          return;
        }

        if (!this.searchUrl) {
          this.resultsContainer.innerHTML = '';
          return;
        }

        // Dieser Block ist ein statischer JavaScript-Tag ohne Liquid-Zugriff;
        // theme.liquid setzt <html lang> auf den aktiven Shopify-Locale.
        const currentLanguage = document.documentElement.lang || '';
        const queryKey = `${currentLanguage || 'default'}::${typedQuery
          .toLowerCase()
          .replace(/\s+/g, '-')}`;

        if (this.cachedResults[queryKey]) {
          this.abortController?.abort();
          this.abortController = null;
          this.renderResults(this.cachedResults[queryKey]);
          return;
        }

        this.renderMessage('site-search-drawer__placeholder', this.loadingLabel);

        let controller = null;

        try {
          this.abortController?.abort();
          controller = new AbortController();
          this.abortController = controller;

          const searchParams = new URLSearchParams({
            q: typedQuery,
            section_id: 'helper-predictive-search',
          });

          searchParams.set('options[prefix]', 'last');

          const response = await fetch(
            `${this.searchUrl}?${searchParams.toString()}`,
            { signal: controller.signal },
          );

          if (!response.ok) {
            throw new Error(`Search request failed with ${response.status}`);
          }

          const text = await response.text();
          const html = new DOMParser().parseFromString(text, 'text/html');
          const results = html.querySelector('#shopify-section-helper-predictive-search')?.innerHTML || '';

          if (!results.trim()) {
            throw new Error('Search results markup missing');
          }

          if (typedQuery !== this.input.value.trim()) {
            return;
          }

          this.cachedResults[queryKey] = results;
          this.renderResults(results);
        } catch (error) {
          if (error.name === 'AbortError') {
            return;
          }

          this.renderMessage('site-search-drawer__empty', this.unavailableLabel);
        } finally {
          if (this.abortController === controller) {
            this.abortController = null;
          }
        }
      }

      renderResults(markup) {
        this.resultsContainer.innerHTML = markup;
        this.results = Array.from(this.resultsContainer.querySelectorAll('[data-predictive-search-item]'));
        this.activeIndex = -1;
      }

      renderMessage(className, message) {
        this.resultsContainer.innerHTML = `<p class="${className}"></p>`;
        const element = this.resultsContainer.querySelector(`.${className}`);
        if (element) {
          element.textContent = message;
        }
        this.results = [];
        this.activeIndex = -1;
      }

      clearResults() {
        this.abortController?.abort();
        this.abortController = null;
        this.resultsContainer.innerHTML = '';
        this.results = [];
        this.activeIndex = -1;
      }

      handleKeydown(event) {
        if (!this.results.length) {
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.navigate(1);
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.navigate(-1);
        }

        if (event.key === 'Enter' && this.activeIndex >= 0) {
          event.preventDefault();
          this.results[this.activeIndex].click();
        }
      }

      navigate(step) {
        if (this.activeIndex >= 0) {
          this.results[this.activeIndex].classList.remove('is-active');
        }

        const nextIndex = this.activeIndex + step;
        if (nextIndex < 0) {
          this.activeIndex = -1;
          return;
        }

        this.activeIndex = Math.min(nextIndex, this.results.length - 1);
        const activeResult = this.results[this.activeIndex];
        activeResult.classList.add('is-active');
        activeResult.scrollIntoView({ block: 'nearest' });
      }
    }

    customElements.define('header-search-form', HeaderSearchForm);
  }

  if (!customElements.get('header-mini-cart')) {
    class HeaderMiniCart extends HTMLElement {
      constructor() {
        super();
        this.cartChangeUrl = this.dataset.cartChangeUrl || '';
        this.errorLabel = this.dataset.errorLabel || "We couldn't update your cart. Please try again.";
      }

      connectedCallback() {
        this.bindEvents();
        this.updateHeaderCount();
      }

      bindEvents() {
        this.querySelectorAll('[data-cart-qty-change]').forEach((button) => {
          button.addEventListener('click', (event) => {
            const item = event.currentTarget.closest('[data-cart-item]');
            const input = item?.querySelector('[data-cart-qty-input]');
            const delta = Number(event.currentTarget.dataset.cartQtyChange || 0);
            const nextQuantity = Math.max(0, Number(input?.value || 0) + delta);

            if (item) {
              this.updateLine(item.dataset.line, nextQuantity);
            }
          });
        });

        this.querySelectorAll('[data-cart-qty-input]').forEach((input) => {
          input.addEventListener('change', (event) => {
            const item = event.currentTarget.closest('[data-cart-item]');
            const nextQuantity = Math.max(0, Number(event.currentTarget.value || 0));

            if (item) {
              this.updateLine(item.dataset.line, nextQuantity);
            }
          });
        });

        this.querySelectorAll('[data-cart-remove]').forEach((button) => {
          button.addEventListener('click', (event) => {
            const item = event.currentTarget.closest('[data-cart-item]');
            if (item) {
              this.updateLine(item.dataset.line, 0);
            }
          });
        });
      }

      async updateLine(line, quantity) {
        this.classList.add('is-loading');

        try {
          const response = await fetch(this.cartChangeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              line: Number(line),
              quantity: Number(quantity),
            }),
          });

          const payload = await response.json();
          await this.refresh();

          if (!response.ok || payload.status === 422) {
            throw new Error(payload.description || payload.message || this.errorLabel);
          }
        } catch (error) {
          this.setFeedback(error.message || this.errorLabel);
        } finally {
          this.classList.remove('is-loading');
        }
      }

      async refresh(openDrawer = false) {
        const response = await fetch('?section_id=helper-cart');
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const content = html.querySelector('#shopify-section-helper-cart');

        if (content) {
          this.innerHTML = content.innerHTML;
          this.bindEvents();
          this.updateHeaderCount();
          this.setFeedback('');
        }

        if (openDrawer && window.AerofoilsHeaderDrawers) {
          window.AerofoilsHeaderDrawers.open('cart');
        }
      }

      updateHeaderCount() {
        const count = Number(this.querySelector('.site-cart-drawer__content')?.dataset.cartCount || 0);
        document.querySelectorAll('[data-header-cart-count]').forEach((counter) => {
          counter.textContent = count;
          counter.classList.toggle('is-hidden', count === 0);
        });
      }

      setFeedback(message) {
        const feedback = this.querySelector('[data-cart-feedback]');
        if (!feedback) {
          return;
        }

        if (message) {
          feedback.hidden = false;
          feedback.textContent = message;
        } else {
          feedback.hidden = true;
          feedback.textContent = '';
        }
      }
    }

    customElements.define('header-mini-cart', HeaderMiniCart);
  }

  if (!window.AerofoilsHeaderDrawers) {
    const closeDrawer = () => {
      const activeDrawer = document.querySelector('.site-header-sidebar.is-active');

      if (!activeDrawer) {
        return;
      }

      activeDrawer.classList.remove('is-active');
      document.body.classList.remove('site-header-sidebar-open');
      syncHeaderOverlayState();

      window.setTimeout(() => {
        activeDrawer.hidden = true;
        syncHeaderOverlayState();
      }, 240);
    };

    const openDrawer = (drawerName) => {
      const drawer = document.querySelector(`[data-header-drawer="${drawerName}"]`);

      if (!drawer) {
        return;
      }

      drawer.hidden = false;
      document.body.classList.add('site-header-sidebar-open');
      syncHeaderOverlayState();

      document.querySelectorAll('.site-header__drawer[open]').forEach((menu) => {
        menu.removeAttribute('open');
      });

      window.AerofoilsCloseDesktopMegaMenus?.({ immediate: true });

      document.querySelectorAll('[data-header-drawer]').forEach((sidebar) => {
        if (sidebar !== drawer) {
          sidebar.classList.remove('is-active');
          sidebar.hidden = true;
        }
      });

      requestAnimationFrame(() => {
        drawer.classList.add('is-active');
      });

      if (drawerName === 'search') {
        window.setTimeout(() => {
          drawer.querySelector('[data-search-input]')?.focus();
        }, 80);
      }
    };

    window.AerofoilsHeaderDrawers = {
      open: openDrawer,
      close: closeDrawer,
    };

    const openCartDrawerWithFreshData = () => {
      if (window.AerofoilsCartUI && typeof window.AerofoilsCartUI.refresh === 'function') {
        return window.AerofoilsCartUI.refresh({ openDrawer: true }).catch((error) => {
          console.error('Cart refresh before open failed:', error);
          openDrawer('cart');
        });
      }

      openDrawer('cart');
      return Promise.resolve();
    };

    window.refreshCart = (openDrawerOnRefresh = true) => {
      if (window.AerofoilsCartUI && typeof window.AerofoilsCartUI.refresh === 'function') {
        return window.AerofoilsCartUI.refresh({ openDrawer: openDrawerOnRefresh });
      }

      document.querySelector('[data-mini-cart]')?.refresh(openDrawerOnRefresh);
      return Promise.resolve();
    };

    document.addEventListener('click', (event) => {
      const searchTrigger = event.target.closest('[data-header-search-trigger]');
      const cartTrigger = event.target.closest('[data-header-cart-trigger]');
      const closeTrigger = event.target.closest('[data-header-drawer-close]');
      const overlay = event.target.closest('[data-header-overlay]');

      if (searchTrigger) {
        event.preventDefault();
        openDrawer('search');
      }

      if (cartTrigger) {
        event.preventDefault();
        openCartDrawerWithFreshData();
      }

      if (closeTrigger || overlay) {
        closeDrawer();

        document.querySelectorAll('.site-header__drawer[open]').forEach((menuDrawer) => {
          menuDrawer.aerofoilsCloseMenu?.();
        });

        window.AerofoilsCloseDesktopMegaMenus?.();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  }

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-custom-cart-change]');

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const line = Number(button.dataset.line);
  const quantity = Math.max(0, Number(button.dataset.quantity));
  const panel = button.closest('.custom-cart-panel');
  const item = button.closest('.custom-cart-item');
  const itemKey = item?.dataset.itemKey || '';
  const isRemoval = quantity === 0;

  if (!panel || panel.classList.contains('is-updating')) {
    return;
  }

  panel.classList.add('is-updating');
  if (item) {
    item.classList.add(isRemoval ? 'is-pending-removal' : 'is-loading');
  }

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity
      })
    });

    const cart = await response.json();

    if (!response.ok) {
      throw new Error(cart.description || 'Cart update failed');
    }

    if (isRemoval && item) {
      item.classList.remove('is-loading', 'is-pending-removal');
      item.classList.add('is-removing');
      await new Promise((resolve) => window.setTimeout(resolve, 180));
    }

    if (window.AerofoilsCartUI) {
      const updateOptions = {
        highlightKey: isRemoval ? '' : itemKey,
      };

      if (typeof window.AerofoilsCartUI.refresh === 'function') {
        await window.AerofoilsCartUI.refresh(updateOptions);
      } else if (typeof window.AerofoilsCartUI.update === 'function') {
        window.AerofoilsCartUI.update(cart, updateOptions);
      }
    }
  } catch (error) {
    item?.classList.remove('is-loading', 'is-pending-removal', 'is-removing');
    console.error('Custom cart update error:', error);
  } finally {
    panel.classList.remove('is-updating');
  }
}, true);

if (!window.AerofoilsAjaxAddToCartReady) {
  window.AerofoilsAjaxAddToCartReady = true;

  const customCartFormatMoney = (cents) => {
    const amount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);

    return customCartMoneySample.replace(/[\d,.]+/, amount);
  };

  const customCartRoot = window.Shopify?.routes?.root || '/';

  const customCartEscape = (value = '') => {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  };

  const cartLabels = () => window.AerofoilsCartLabels || {};

  const cartLabel = (key, title = '') => {
    const value = cartLabels()[key];
    if (typeof value !== 'string') {
      return '';
    }
    return value.replaceAll('%%TITLE%%', () => title);
  };

  const customCartTrashIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3.33203 5.83333H16.6654" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.33203 9.16667V14.1667" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.668 9.16667V14.1667" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.16797 5.83333L5.0013 15.8333C5.0013 16.2754 5.1769 16.6993 5.48946 17.0118C5.80202 17.3244 6.22594 17.5 6.66797 17.5H13.3346C13.7767 17.5 14.2006 17.3244 14.5131 17.0118C14.8257 16.6993 15.0013 16.2754 15.0013 15.8333L15.8346 5.83333" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const customCartMinusIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M4.16797 10H15.8346" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const customCartPlusIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 4.16666V15.8333" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.16797 10H15.8346" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const customCartCloseIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M15 5L5 15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 5L15 15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const customCartBackIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M4.16797 10H15.8346" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.16797 10L7.5013 13.3333" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.16797 10L7.5013 6.66669" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const updateCustomHeaderCartCount = (cart) => {
    document.querySelectorAll('[data-header-cart-count]').forEach((counter) => {
      counter.textContent = cart.item_count;
      counter.classList.toggle('is-hidden', cart.item_count === 0);
    });
  };

  const shouldHideCustomCartItem = (item = {}) => {
    const quantity = Number(item.quantity || 0);
    const title = String(item.product_title || item.title || '').toLowerCase();
    const finalLinePrice = Number(item.final_line_price || 0);

    if (quantity <= 0) {
      return true;
    }

    return title.includes('(parent)') && finalLinePrice === 0;
  };

  const getVisibleCustomCartItems = (cart) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];

    return items.reduce((result, item, index) => {
      if (shouldHideCustomCartItem(item)) {
        return result;
      }

      result.push({
        ...item,
        __line: index + 1,
      });

      return result;
    }, []);
  };

  const renderCustomCartDrawer = (cart, options = {}) => {
    const panel = document.querySelector('[data-header-drawer="cart"] .custom-cart-panel');

    if (!panel) return;

    const visibleItems = getVisibleCustomCartItems(cart);

    const itemsMarkup = visibleItems.map((item) => {
      const line = item.__line;
      const itemKey = item.key || '';
      const bundleDisplay = item.properties && item.properties._aerofoils_display
        ? String(item.properties._aerofoils_display)
        : '';
      const addonParent = item.properties && item.properties._aerofoils_addon_parent
        ? String(item.properties._aerofoils_addon_parent)
        : '';
      const addonGroup = item.properties && item.properties._aerofoils_addon_group
        ? String(item.properties._aerofoils_addon_group)
        : '';
      const addonOption = item.properties && item.properties._aerofoils_addon_option
        ? String(item.properties._aerofoils_addon_option)
        : '';
      const addonSize = item.properties && item.properties._aerofoils_addon_size
        ? String(item.properties._aerofoils_addon_size)
        : '';
      const isBundleParent = !!(bundleDisplay || (item.properties && item.properties._aerofoils_config));
      const isBundleAddon = !!addonParent;
      const image = item.image
        ? `<img src="${customCartEscape(item.image)}" alt="${customCartEscape(item.product_title)}" loading="lazy" class="custom-cart-product-img">`
        : '';

      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="custom-cart-options"><span>${customCartEscape(item.variant_title)}</span></div>`
        : '';

      const propertiesMarkup = item.properties
        ? Object.entries(item.properties)
          .filter(([key, value]) => value && !String(key).startsWith('_'))
          .map(([, value]) => `<span>${customCartEscape(value)}</span>`)
          .join('')
        : '';
      const bundleMeta = isBundleParent && bundleDisplay
        ? `<div class="custom-cart-options"><span>${customCartEscape(bundleDisplay)}</span></div>`
        : isBundleAddon
          ? `<div class="custom-cart-options"><span>${customCartEscape(addonGroup || cartLabel('addon'))}: ${customCartEscape(addonOption || item.product_title)}${addonSize ? ` · ${customCartEscape(addonSize)}` : ''}</span></div>`
          : '';

      const itemClasses = ['custom-cart-item'];
      if (options.highlightKey && itemKey === options.highlightKey) {
        itemClasses.push('is-highlighted');
      }

      return `
        <div class="${itemClasses.join(' ')}" data-item-key="${customCartEscape(itemKey)}">
          <div class="custom-cart-image">
            ${image}
          </div>

          <div class="custom-cart-info">
            <div class="custom-cart-top">
              <a href="${customCartEscape(item.url)}" class="custom-cart-title">
                ${customCartEscape(item.product_title)}
              </a>

              <button
                type="button"
                class="custom-cart-remove"
                aria-label="${customCartEscape(cartLabel('removeItem', item.product_title))}"
                data-custom-cart-change
                data-line="${line}"
                data-quantity="0"
              >
                ${customCartTrashIcon}
              </button>
            </div>

            ${variantTitle}
            ${bundleMeta}
            ${propertiesMarkup ? `<div class="custom-cart-options">${propertiesMarkup}</div>` : ''}

            <div class="custom-cart-bottom">
              <div class="custom-cart-price">
                ${customCartFormatMoney(item.final_line_price, cart.currency)}
              </div>

              <div class="custom-cart-qty">
                <button
                  type="button"
                  class="custom-cart-qty-btn"
                  data-custom-cart-change
                  data-line="${line}"
                  data-quantity="${Math.max(0, item.quantity - 1)}"
                  aria-label="${customCartEscape(cartLabel('decreaseQuantity'))}"
                  ${isBundleParent ? 'disabled' : ''}
                >
                  ${customCartMinusIcon}
                </button>

                <input type="number" name="updates[]" value="${item.quantity}" min="0" aria-label="${customCartEscape(cartLabel('quantityFor', item.product_title))}" ${isBundleParent ? 'readonly disabled' : ''}>

                <button
                  type="button"
                  class="custom-cart-qty-btn"
                  data-custom-cart-change
                  data-line="${line}"
                  data-quantity="${item.quantity + 1}"
                  aria-label="${customCartEscape(cartLabel('increaseQuantity'))}"
                  ${isBundleParent ? 'disabled' : ''}
                >
                  ${customCartPlusIcon}
                </button>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');

    // Regional sales restriction (dealer / inquiry): keep the info box and
    // hide the checkout button when a rule applies (server-side country match
    // or province match resolved by assets/region-sales.js).
    const regionSalesRoot = panel.closest('[data-region-sales-section]');
    const regionSalesTemplate = regionSalesRoot
      ? regionSalesRoot.querySelector('[data-region-sales-cart-notice-template]')
      : null;
    const regionSalesNoticeMarkup = regionSalesTemplate ? regionSalesTemplate.innerHTML : '';
    const regionSalesActive = !!regionSalesRoot
      && (regionSalesRoot.dataset.regionSalesActive === 'true' || !!regionSalesRoot.dataset.regionSalesActiveRule);
    const regionSalesCheckoutMarkup = regionSalesActive
      ? ''
      : `
                  ${regionSalesRoot ? '<div class="region-sales-default" data-region-sales-default>' : ''}
                  <button type="submit" name="checkout" class="custom-cart-checkout">
                    ${customCartEscape(cartLabel('checkout'))}
                  </button>
                  ${regionSalesRoot ? '</div>' : ''}
                `;

    panel.innerHTML = `
      <div class="custom-cart-header">
        <h2>${customCartEscape(cartLabel('title'))}</h2>

        <button class="custom-cart-close" type="button" aria-label="${customCartEscape(cartLabel('close'))}" data-header-drawer-close>
          ${customCartCloseIcon}
        </button>
      </div>

      ${
        visibleItems.length > 0
          ? `
            <form action="${customCartRoot}cart" method="post" novalidate class="custom-cart-form">
              <div class="custom-cart-items">
                ${itemsMarkup}
              </div>

              ${regionSalesNoticeMarkup}

              <div class="custom-cart-footer">
                <div class="custom-cart-total">
                  <span>${customCartEscape(cartLabel('total'))}</span>
                  <strong>${customCartFormatMoney(cart.total_price, cart.currency)}</strong>
                </div>

                <div class="custom-cart-actions">
                  ${regionSalesCheckoutMarkup}
                </div>
              </div>
            </form>
          `
          : `
            <div class="custom-cart-empty">
              <p>${customCartEscape(cartLabel('empty'))}</p>
              <a href="${customCartRoot}collections/all" class="custom-cart-checkout">
                ${customCartEscape(cartLabel('backToCatalogue'))}
              </a>
            </div>
          `
      }
    `;
  };

  window.AerofoilsCartUI = {
    update(cart, options = {}) {
      if (!cart) return;

      updateCustomHeaderCartCount(cart);
      renderCustomCartDrawer(cart, options);

      if (options.openDrawer && window.AerofoilsHeaderDrawers) {
        window.AerofoilsHeaderDrawers.open('cart');
      }
    },

    async refresh(options = {}) {
      const cartResponse = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });
      const cart = await cartResponse.json();

      window.AerofoilsCartUI.update(cart, options);

      return cart;
    }
  };

  const getAddToCartButtons = (form, submitter = null) => {
    const buttons = new Set();

    const maybeAddButton = (button) => {
      if (!button || typeof button.matches !== 'function') {
        return;
      }

      if (!button.matches('button[type="submit"], input[type="submit"]')) {
        return;
      }

      buttons.add(button);
    };

    maybeAddButton(submitter);
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(maybeAddButton);

    const formId = form.getAttribute('id');
    if (formId) {
      const escapedFormId = window.CSS && typeof window.CSS.escape === 'function'
        ? window.CSS.escape(formId)
        : formId.replace(/"/g, '\\"');

      document
        .querySelectorAll(`button[type="submit"][form="${escapedFormId}"], input[type="submit"][form="${escapedFormId}"]`)
        .forEach(maybeAddButton);
    }

    return Array.from(buttons);
  };

  const setAddToCartButtonsState = (buttons, state) => {
    buttons.forEach((button) => {
      if (button.dataset.wasDisabledBeforeSubmit == null) {
        button.dataset.wasDisabledBeforeSubmit = button.disabled ? 'true' : 'false';
      }

      const labelNode = button.querySelector('[data-product-submit-label]');

      if (state === 'loading') {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.classList.remove('is-added');
        button.classList.add('is-loading');

        if (labelNode && button.dataset.addToCartLoadingLabel) {
          labelNode.textContent = button.dataset.addToCartLoadingLabel;
        }

        return;
      }

      if (state === 'success') {
        button.disabled = true;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.classList.add('is-added');

        if (labelNode && button.dataset.addToCartSuccessLabel) {
          labelNode.textContent = button.dataset.addToCartSuccessLabel;
        }

        return;
      }

      const wasDisabledBeforeSubmit = button.dataset.wasDisabledBeforeSubmit === 'true';
      button.disabled = wasDisabledBeforeSubmit;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading', 'is-added');

      if (labelNode && button.dataset.addToCartDefaultLabel) {
        labelNode.textContent = button.dataset.addToCartDefaultLabel;
      }

      delete button.dataset.wasDisabledBeforeSubmit;
    });
  };

  const pulseHeaderCartTrigger = () => {
    document.querySelectorAll('[data-header-cart-trigger]').forEach((trigger) => {
      trigger.classList.remove('is-bumping');
      void trigger.offsetWidth;
      trigger.classList.add('is-bumping');

      window.setTimeout(() => {
        trigger.classList.remove('is-bumping');
      }, 520);
    });
  };

  window.AerofoilsCartUI.setAddToCartButtonsState = setAddToCartButtonsState;
  window.AerofoilsCartUI.pulseHeaderCartTrigger = pulseHeaderCartTrigger;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');

    if (!form) return;
    if (form.dataset.aerofoilsBundleAddons === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    const submitButtons = getAddToCartButtons(form, event.submitter || null);
    setAddToCartButtonsState(submitButtons, 'loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json'
        }
      });

      const payload = await response.json();

      if (!response.ok) {
        throw new Error(payload.description || payload.message || 'Add to cart failed');
      }

      await window.AerofoilsCartUI.refresh({ openDrawer: true });
      pulseHeaderCartTrigger();
      setAddToCartButtonsState(submitButtons, 'success');
      await new Promise((resolve) => window.setTimeout(resolve, 1200));
    } catch (error) {
      console.error('Add to cart error:', error);
    } finally {
      setAddToCartButtonsState(submitButtons, 'default');
    }
  }, true);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const createHeaderDebounce = (callback, wait = 180) => {
    let timeout;

    return (...args) => {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => callback(...args), wait);
    };
  };

  const HEADER_OVERLAY_MODE_CLASSES = [
    'site-header-overlay--sidebar',
    'site-header-overlay--menu',
    'site-header-overlay--drawer',
    'site-header-overlay--mega',
  ];

  const getHeaderOverlayMode = () => {
    if (document.body.classList.contains('site-header-sidebar-open')) {
      return 'sidebar';
    }

    if (document.querySelector('.site-header__drawer[open]:not(.is-closing)')) {
      return 'drawer';
    }

    if (document.querySelector('.site-header__desktop-disclosure--mega.is-panel-visible')) {
      return 'mega';
    }

    return '';
  };

  const clearHeaderOverlayAnimation = (overlay) => {
    if (overlay._headerOverlayShowFrame) {
      window.cancelAnimationFrame(overlay._headerOverlayShowFrame);
      overlay._headerOverlayShowFrame = null;
    }

    if (overlay._headerOverlayHideTimer) {
      window.clearTimeout(overlay._headerOverlayHideTimer);
      overlay._headerOverlayHideTimer = null;
    }
  };

  const getHeaderOverlayHideDuration = (mode) => {
    if (mode === 'drawer') {
      return 420;
    }

    if (mode === 'mega') {
      return 280;
    }

    return 240;
  };

  const applyHeaderOverlayMode = (overlay, mode) => {
    overlay.classList.remove(...HEADER_OVERLAY_MODE_CLASSES);

    if (mode === 'sidebar') {
      overlay.classList.add('site-header-overlay--sidebar');
    } else if (mode === 'drawer') {
      overlay.classList.add('site-header-overlay--menu', 'site-header-overlay--drawer');
    } else if (mode === 'mega') {
      overlay.classList.add('site-header-overlay--menu', 'site-header-overlay--mega');
    }

    overlay.dataset.overlayMode = mode;
  };

  const syncHeaderOverlayState = () => {
    const overlay = document.querySelector('[data-header-overlay]');

    if (!overlay) {
      return;
    }

    const nextMode = getHeaderOverlayMode();
    const hasMenuOpen = Boolean(document.querySelector('.site-header__drawer[open]'))
      || Boolean(document.querySelector('.site-header__desktop-disclosure[open]'));

    clearHeaderOverlayAnimation(overlay);
    document.body.classList.toggle('site-header-menu-open', hasMenuOpen);

    if (nextMode === '') {
      if (!overlay.classList.contains('is-visible')) {
        overlay.hidden = true;
        overlay.classList.remove(...HEADER_OVERLAY_MODE_CLASSES);
        overlay.dataset.overlayMode = '';
        return;
      }

      const currentMode = overlay.dataset.overlayMode || '';
      overlay.classList.remove('is-visible');
      overlay._headerOverlayHideTimer = window.setTimeout(() => {
        overlay.hidden = true;
        overlay.classList.remove(...HEADER_OVERLAY_MODE_CLASSES);
        overlay.dataset.overlayMode = '';
        overlay._headerOverlayHideTimer = null;
      }, getHeaderOverlayHideDuration(currentMode));
      return;
    }

    const modeChanged = overlay.dataset.overlayMode !== nextMode;

    applyHeaderOverlayMode(overlay, nextMode);

    if (overlay.hidden) {
      overlay.hidden = false;
      overlay._headerOverlayShowFrame = window.requestAnimationFrame(() => {
        overlay._headerOverlayShowFrame = window.requestAnimationFrame(() => {
          overlay.classList.add('is-visible');
          overlay._headerOverlayShowFrame = null;
        });
      });
      return;
    }

    if (modeChanged) {
      overlay.offsetHeight;
    }

    overlay.classList.add('is-visible');
  };

  window.AerofoilsSyncHeaderOverlayState = syncHeaderOverlayState;

  const initDesktopHeaderMenus = () => {
    const desktopMedia = window.matchMedia('(min-width: 1025px)');
    const desktopDisclosures = Array.from(document.querySelectorAll('.site-header__desktop-disclosure'));
    const hoverCloseDelay = 200;
    const panelAnimationDuration = 280;

    if (!desktopDisclosures.length) {
      return;
    }

    const clearCloseTimer = (disclosure) => {
      if (disclosure.headerCloseTimer) {
        window.clearTimeout(disclosure.headerCloseTimer);
        disclosure.headerCloseTimer = null;
      }
    };

    const clearAnimationTimer = (disclosure) => {
      if (disclosure.headerAnimationTimer) {
        window.clearTimeout(disclosure.headerAnimationTimer);
        disclosure.headerAnimationTimer = null;
      }
    };

    const closeDisclosure = (disclosure, options = {}) => {
      const { immediate = false } = options;
      const summary = disclosure.querySelector('summary');
      clearCloseTimer(disclosure);
      disclosure.dataset.openMode = '';
      summary?.setAttribute('aria-expanded', 'false');

      if (!disclosure.open) {
        disclosure.classList.remove('is-panel-visible');
        disclosure.classList.remove('is-panel-closing');
        clearAnimationTimer(disclosure);
        syncHeaderOverlayState();
        return;
      }

      if (!disclosure.classList.contains('site-header__desktop-disclosure--mega') || immediate) {
        clearAnimationTimer(disclosure);
        disclosure.classList.remove('is-panel-visible');
        disclosure.classList.remove('is-panel-closing');
        disclosure.open = false;
        syncHeaderOverlayState();
        return;
      }

      clearAnimationTimer(disclosure);
      disclosure.classList.remove('is-panel-visible');
      disclosure.classList.add('is-panel-closing');
      syncHeaderOverlayState();
      disclosure.headerAnimationTimer = window.setTimeout(() => {
        disclosure.open = false;
        disclosure.classList.remove('is-panel-closing');
        disclosure.headerAnimationTimer = null;
        syncHeaderOverlayState();
      }, panelAnimationDuration);
    };

    const closeAllDisclosures = (exceptDisclosure = null, options = {}) => {
      document.querySelectorAll('.site-header__desktop-disclosure').forEach((disclosure) => {
        if (disclosure !== exceptDisclosure) {
          closeDisclosure(disclosure, options);
        }
      });
    };

    const openDisclosure = (disclosure, mode) => {
      if (!desktopMedia.matches) {
        return;
      }

      const summary = disclosure.querySelector('summary');
      clearCloseTimer(disclosure);
      clearAnimationTimer(disclosure);
      closeAllDisclosures(disclosure);
      disclosure.classList.remove('is-panel-closing');

      if (!disclosure.open) {
        disclosure.open = true;
      }

      disclosure.dataset.openMode = mode;
      summary?.setAttribute('aria-expanded', 'true');

      if (disclosure.classList.contains('site-header__desktop-disclosure--mega')) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            disclosure.classList.add('is-panel-visible');
            syncHeaderOverlayState();
          });
        });
      }
    };

    const scheduleCloseDisclosure = (disclosure) => {
      clearCloseTimer(disclosure);
      disclosure.headerCloseTimer = window.setTimeout(() => {
        closeDisclosure(disclosure);
      }, hoverCloseDelay);
    };

    const toggleDisclosure = (disclosure) => {
      if (disclosure.open && disclosure.dataset.openMode === 'click') {
        closeDisclosure(disclosure);
        return;
      }

      openDisclosure(disclosure, 'click');
    };

    desktopDisclosures.forEach((disclosure) => {
      if (disclosure.dataset.desktopMenuReady === 'true') {
        return;
      }

      const summary = disclosure.querySelector('summary');
      if (!summary) {
        return;
      }

      disclosure.dataset.desktopMenuReady = 'true';
      summary.setAttribute('aria-expanded', disclosure.hasAttribute('open') ? 'true' : 'false');
      disclosure.classList.toggle('is-panel-visible', disclosure.hasAttribute('open'));

      summary.addEventListener('click', (event) => {
        if (!desktopMedia.matches) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        toggleDisclosure(disclosure);
      });

      disclosure.addEventListener('mouseenter', () => {
        if (!desktopMedia.matches || disclosure.dataset.openMode === 'click') {
          return;
        }

        clearCloseTimer(disclosure);
        openDisclosure(disclosure, 'hover');
      });

      disclosure.addEventListener('mouseleave', () => {
        if (!desktopMedia.matches || disclosure.dataset.openMode === 'click') {
          return;
        }

        scheduleCloseDisclosure(disclosure);
      });
    });

    if (window.AerofoilsHeaderDesktopMenusBound) {
      return;
    }

    window.AerofoilsHeaderDesktopMenusBound = true;
    window.AerofoilsCloseDesktopMegaMenus = (options = {}) => {
      closeAllDisclosures(null, options);
    };

    document.addEventListener('click', (event) => {
      if (!desktopMedia.matches) {
        return;
      }

      document.querySelectorAll('.site-header__desktop-disclosure').forEach((disclosure) => {
        if (disclosure.dataset.openMode === 'click' && !disclosure.contains(event.target)) {
          closeDisclosure(disclosure);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllDisclosures();
      }
    });

    const handleBreakpointChange = (mediaQuery) => {
      if (!mediaQuery.matches) {
        closeAllDisclosures(null, { immediate: true });
      }
    };

    if (typeof desktopMedia.addEventListener === 'function') {
      desktopMedia.addEventListener('change', handleBreakpointChange);
    } else if (typeof desktopMedia.addListener === 'function') {
      desktopMedia.addListener(handleBreakpointChange);
    }

    syncHeaderOverlayState();
  };

  initDesktopHeaderMenus();

  if (!window.AerofoilsHeaderDesktopMenusSectionLoadBound) {
    document.addEventListener('shopify:section:load', initDesktopHeaderMenus);
    window.AerofoilsHeaderDesktopMenusSectionLoadBound = true;
  }

  const initShopMegaMenus = () => {
    document.querySelectorAll('[data-shop-mega]').forEach((menu) => {
      if (menu.dataset.shopMegaReady === 'true') {
        return;
      }

      const triggers = Array.from(menu.querySelectorAll('[data-shop-nav-trigger]'));
      const stages = Array.from(menu.querySelectorAll('[data-shop-stage]'));

      if (!stages.length) {
        return;
      }

      menu.dataset.shopMegaReady = 'true';

      const activateStage = (requestedKey = 'default') => {
        const activeKey = requestedKey || 'default';

        triggers.forEach((trigger) => {
          trigger.classList.toggle('is-active', trigger.dataset.shopNavTrigger === activeKey);
        });

        stages.forEach((stage) => {
          stage.classList.toggle('is-active', stage.dataset.shopStage === activeKey);
        });
      };

      activateStage('default');

      triggers.forEach((trigger) => {
        const stageKey = trigger.dataset.shopNavTrigger || 'default';

        trigger.addEventListener('mouseenter', () => {
          activateStage(stageKey);
        });

        trigger.addEventListener('focus', () => {
          activateStage(stageKey);
        });

        trigger.addEventListener('click', () => {
          activateStage(stageKey);
        });
      });

      menu.addEventListener('mouseleave', () => {
        activateStage('default');
      });

      menu.addEventListener('toggle', () => {
        if (!menu.open) {
          activateStage('default');
        }
      });
    });
  };

  initShopMegaMenus();

  if (!window.AerofoilsShopMegaMenusBound) {
    document.addEventListener('shopify:section:load', initShopMegaMenus);
    window.AerofoilsShopMegaMenusBound = true;
  }

  const initEfoilsMegaMenus = () => {
    document.querySelectorAll('[data-efoils-mega]').forEach((menu) => {
      if (menu.dataset.efoilsMegaReady === 'true') {
        return;
      }

      const triggers = Array.from(menu.querySelectorAll('[data-efoils-nav-trigger]'));
      const banners = Array.from(menu.querySelectorAll('[data-efoils-banner]'));

      if (!triggers.length || !banners.length) {
        return;
      }

      menu.dataset.efoilsMegaReady = 'true';

      const fallbackKey = triggers[0]?.dataset.efoilsNavTrigger || '';

      const activateBanner = (requestedKey) => {
        const activeKey = requestedKey || fallbackKey;

        triggers.forEach((trigger) => {
          trigger.classList.toggle('is-active', trigger.dataset.efoilsNavTrigger === activeKey);
        });

        banners.forEach((banner) => {
          banner.classList.toggle('is-active', banner.dataset.efoilsBanner === activeKey);
        });
      };

      const initialKey =
        triggers.find((trigger) => trigger.classList.contains('is-active'))?.dataset.efoilsNavTrigger ||
        fallbackKey;

      activateBanner(initialKey);

      triggers.forEach((trigger) => {
        const bannerKey = trigger.dataset.efoilsNavTrigger || '';

        trigger.addEventListener('mouseenter', () => {
          activateBanner(bannerKey);
        });

        trigger.addEventListener('focus', () => {
          activateBanner(bannerKey);
        });

        trigger.addEventListener('click', () => {
          activateBanner(bannerKey);
        });
      });
    });
  };

  initEfoilsMegaMenus();

  if (!window.AerofoilsEfoilsMegaMenusBound) {
    document.addEventListener('shopify:section:load', initEfoilsMegaMenus);
    window.AerofoilsEfoilsMegaMenusBound = true;
  }

  const initHeaderMenuDrawerViews = () => {
    document.querySelectorAll('.site-header__drawer').forEach((drawer) => {
      if (drawer.dataset.headerMenuReady === 'true') {
        return;
      }

      drawer.dataset.headerMenuReady = 'true';

      const views = Array.from(drawer.querySelectorAll('[data-header-drawer-view]'));
      const openViewTriggers = Array.from(drawer.querySelectorAll('[data-header-drawer-open]'));
      const backTriggers = Array.from(drawer.querySelectorAll('[data-header-drawer-back]'));
      const closeTriggers = Array.from(drawer.querySelectorAll('[data-header-menu-close]'));
      const shopView = drawer.querySelector('[data-header-drawer-view="shop"]');
      const shopAccordions = Array.from(drawer.querySelectorAll('[data-shop-accordion]'));
      const SHOP_ACCORDION_DURATION = 280;
      const DRAWER_VIEW_DURATION = 360;
      const DRAWER_CLOSE_DURATION = 420;
      const VIEW_TRANSITION_CLASSES = [
        'is-active',
        'is-underlay',
        'is-entering-from-right',
        'is-entering-from-left',
        'is-exiting-to-left',
        'is-exiting-to-right',
      ];
      let activeViewName = 'main';

      const prefersReducedMotion = () =>
        window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const getView = (viewName) =>
        views.find((view) => view.dataset.headerDrawerView === viewName) || null;

      const getShopAccordionParts = (accordion) => ({
        summary: accordion.querySelector('.site-header__shop-accordion-summary'),
        content: accordion.querySelector('.site-header__shop-accordion-content'),
      });

      const resetViewClasses = (view) => {
        view.classList.remove.apply(view.classList, VIEW_TRANSITION_CLASSES);
      };

      const clearDrawerViewAnimation = () => {
        if (drawer._headerDrawerViewAnimationFrame) {
          window.cancelAnimationFrame(drawer._headerDrawerViewAnimationFrame);
          drawer._headerDrawerViewAnimationFrame = null;
        }

        if (drawer._headerDrawerViewTimer) {
          window.clearTimeout(drawer._headerDrawerViewTimer);
          drawer._headerDrawerViewTimer = null;
        }

        drawer.classList.remove('is-drawer-view-transitioning');
      };

      const clearDrawerCloseAnimation = () => {
        if (drawer._headerDrawerCloseTimer) {
          window.clearTimeout(drawer._headerDrawerCloseTimer);
          drawer._headerDrawerCloseTimer = null;
        }

        drawer.classList.remove('is-closing');
      };

      const clearPendingShopReset = () => {
        if (drawer._headerShopResetTimer) {
          window.clearTimeout(drawer._headerShopResetTimer);
          drawer._headerShopResetTimer = null;
        }
      };

      const syncDrawerViewState = (viewName) => {
        clearDrawerViewAnimation();

        views.forEach((view) => {
          const isActive = view.dataset.headerDrawerView === viewName;

          resetViewClasses(view);
          view.hidden = !isActive;
          view.classList.toggle('is-active', isActive);
        });

        activeViewName = viewName;
        drawer.dataset.activeDrawerView = viewName;
      };

      const clearShopAccordionAnimation = (accordion) => {
        const animationState = accordion._shopAccordionAnimation;

        if (!animationState) {
          return;
        }

        window.clearTimeout(animationState.fallbackTimer);
        animationState.content.removeEventListener(
          'transitionend',
          animationState.onTransitionEnd
        );
        accordion._shopAccordionAnimation = null;
      };

      const syncShopAccordionState = (accordion, expanded) => {
        const { summary, content } = getShopAccordionParts(accordion);

        if (!summary || !content) {
          return;
        }

        clearShopAccordionAnimation(accordion);
        accordion.open = expanded;
        accordion.classList.remove('is-opening', 'is-closing');
        accordion.dataset.shopAccordionAnimating = 'false';
        summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        content.setAttribute('aria-hidden', expanded ? 'false' : 'true');
        content.style.height = expanded ? 'auto' : '0px';
      };

      const syncShopDrawerState = () => {
        if (!shopView) {
          return;
        }

        const hasOpenAccordion = shopAccordions.some((accordion) => accordion.open);
        shopView.classList.toggle('has-open-accordion', hasOpenAccordion);
      };

      const resetShopDrawerState = () => {
        clearPendingShopReset();

        shopAccordions.forEach((accordion) => {
          syncShopAccordionState(accordion, false);
        });
        syncShopDrawerState();
      };

      const animateShopAccordion = (accordion, expanded) => {
        const { summary, content } = getShopAccordionParts(accordion);

        if (!summary || !content) {
          return;
        }

        if (prefersReducedMotion()) {
          syncShopAccordionState(accordion, expanded);
          syncShopDrawerState();
          return;
        }

        clearShopAccordionAnimation(accordion);

        let isFinished = false;

        const finish = () => {
          if (isFinished) {
            return;
          }

          isFinished = true;
          clearShopAccordionAnimation(accordion);
          accordion.open = expanded;
          accordion.classList.remove('is-opening', 'is-closing');
          accordion.dataset.shopAccordionAnimating = 'false';
          summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          content.setAttribute('aria-hidden', expanded ? 'false' : 'true');
          content.style.height = expanded ? 'auto' : '0px';
          syncShopDrawerState();
        };

        const onTransitionEnd = (event) => {
          if (event.target !== content || event.propertyName !== 'height') {
            return;
          }

          finish();
        };

        accordion.dataset.shopAccordionAnimating = 'true';
        accordion.classList.toggle('is-opening', expanded);
        accordion.classList.toggle('is-closing', !expanded);

        if (expanded) {
          const startHeight = content.getBoundingClientRect().height;

          accordion.open = true;
          summary.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
          content.style.height = `${startHeight}px`;
          content.offsetHeight;

          const targetHeight = content.scrollHeight;

          accordion._shopAccordionAnimation = {
            content,
            onTransitionEnd,
            fallbackTimer: window.setTimeout(
              finish,
              SHOP_ACCORDION_DURATION + 80
            ),
          };

          content.addEventListener('transitionend', onTransitionEnd);
          syncShopDrawerState();

          window.requestAnimationFrame(() => {
            content.style.height = `${targetHeight}px`;
          });

          return;
        }

        const startHeight = content.getBoundingClientRect().height || content.scrollHeight;

        content.style.height = `${startHeight}px`;
        content.offsetHeight;
        accordion._shopAccordionAnimation = {
          content,
          onTransitionEnd,
          fallbackTimer: window.setTimeout(finish, SHOP_ACCORDION_DURATION + 80),
        };

        content.addEventListener('transitionend', onTransitionEnd);

        window.requestAnimationFrame(() => {
          content.style.height = '0px';
        });
      };

      const animateDrawerView = (viewName, direction) => {
        const currentView = getView(activeViewName) || getView('main');
        const nextView = getView(viewName);

        if (!currentView || !nextView || currentView === nextView) {
          syncDrawerViewState(viewName);
          return;
        }

        clearDrawerViewAnimation();
        drawer.classList.add('is-drawer-view-transitioning');

        views.forEach((view) => {
          resetViewClasses(view);
        });

        currentView.hidden = false;
        nextView.hidden = false;
        currentView.classList.add('is-active');
        nextView.classList.add('is-active');

        if (direction === 'back') {
          nextView.classList.add('is-underlay', 'is-entering-from-left');

          drawer._headerDrawerViewAnimationFrame = window.requestAnimationFrame(() => {
            drawer._headerDrawerViewAnimationFrame = window.requestAnimationFrame(() => {
              nextView.classList.remove('is-entering-from-left');
              currentView.classList.add('is-exiting-to-right');
            });
          });
        } else {
          currentView.classList.add('is-underlay');
          nextView.classList.add('is-entering-from-right');

          drawer._headerDrawerViewAnimationFrame = window.requestAnimationFrame(() => {
            drawer._headerDrawerViewAnimationFrame = window.requestAnimationFrame(() => {
              currentView.classList.add('is-exiting-to-left');
              nextView.classList.remove('is-entering-from-right');
            });
          });
        }

        drawer._headerDrawerViewTimer = window.setTimeout(() => {
          syncDrawerViewState(viewName);
        }, DRAWER_VIEW_DURATION + 60);
      };

      const showView = (viewName, options = {}) => {
        const immediate = options.immediate === true;
        const direction = options.direction || (viewName === 'main' ? 'back' : 'forward');

        if (immediate || !drawer.open || prefersReducedMotion()) {
          syncDrawerViewState(viewName);
          return;
        }

        animateDrawerView(viewName, direction);
      };

      const closeDrawer = () => {
        if (!drawer.open || drawer.classList.contains('is-closing')) {
          return;
        }

        if (prefersReducedMotion()) {
          drawer.removeAttribute('open');
          syncHeaderOverlayState();
          return;
        }

        clearDrawerCloseAnimation();
        drawer.classList.add('is-closing');
        syncHeaderOverlayState();
        drawer._headerDrawerCloseTimer = window.setTimeout(() => {
          drawer.removeAttribute('open');
        }, DRAWER_CLOSE_DURATION);
      };

      drawer.aerofoilsCloseMenu = closeDrawer;

      showView('main', { immediate: true });
      syncShopDrawerState();

      shopAccordions.forEach((accordion) => {
        const { summary } = getShopAccordionParts(accordion);

        if (!summary) {
          return;
        }

        syncShopAccordionState(accordion, accordion.open);

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          const shouldExpand = !accordion.open;

          if (shouldExpand) {
            shopAccordions.forEach((otherAccordion) => {
              if (otherAccordion !== accordion && otherAccordion.open) {
                animateShopAccordion(otherAccordion, false);
              }
            });
          }

          animateShopAccordion(accordion, shouldExpand);
        });
      });

      openViewTriggers.forEach((trigger) => {
        const viewName = trigger.dataset.headerDrawerOpen || 'main';

        trigger.addEventListener('click', (event) => {
          event.preventDefault();

          if (viewName !== 'shop') {
            resetShopDrawerState();
          }

          showView(viewName, { direction: 'forward' });
        });
      });

      backTriggers.forEach((trigger) => {
        const viewName = trigger.dataset.headerDrawerBack || 'main';

        trigger.addEventListener('click', (event) => {
          event.preventDefault();

          if (activeViewName === 'shop' && viewName === 'main' && !prefersReducedMotion()) {
            clearPendingShopReset();
            drawer._headerShopResetTimer = window.setTimeout(() => {
              resetShopDrawerState();
            }, DRAWER_VIEW_DURATION + 60);
          } else {
            resetShopDrawerState();
          }

          showView(viewName, { direction: 'back' });
        });
      });

      closeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          closeDrawer();
        });
      });

      drawer.addEventListener('toggle', () => {
        clearDrawerCloseAnimation();

        if (drawer.open) {
          showView('main', { immediate: true });
          syncShopDrawerState();
          syncHeaderOverlayState();
          return;
        }

        clearDrawerViewAnimation();
        resetShopDrawerState();
        showView('main', { immediate: true });
        syncHeaderOverlayState();
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
          return;
        }

        if (drawer.classList.contains('is-closing')) {
          event.preventDefault();
          return;
        }

        if (!drawer.open) {
          return;
        }

        event.preventDefault();
        closeDrawer();
      });
    });
  };

  initHeaderMenuDrawerViews();

  if (!window.AerofoilsHeaderMenuDrawerViewsBound) {
    document.addEventListener('shopify:section:load', initHeaderMenuDrawerViews);
    window.AerofoilsHeaderMenuDrawerViewsBound = true;
  }

  const isHeaderInteractionOpen = () =>
    document.body.classList.contains('site-header-sidebar-open') ||
    Boolean(document.querySelector('.site-header__drawer[open]')) ||
    Boolean(document.querySelector('.site-header__desktop-disclosure[open]'));

  const initHeaderRevealOnScroll = () => {
    const header = document.querySelector('.site-header');

    if (!header) {
      return;
    }

    if (!window.AerofoilsHeaderScrollReveal) {
      let lastScrollY = window.scrollY;
      let ticking = false;
      const scrollThreshold = 12;
      const topOffset = 24;

      const sync = () => {
        const currentHeader = document.querySelector('.site-header');

        if (!currentHeader) {
          ticking = false;
          return;
        }

        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > lastScrollY;
        const scrollDelta = Math.abs(currentScrollY - lastScrollY);

        if (currentScrollY <= topOffset || isHeaderInteractionOpen()) {
          currentHeader.classList.remove('is-scroll-hidden');
          lastScrollY = currentScrollY;
          ticking = false;
          return;
        }

        if (scrollDelta >= scrollThreshold) {
          currentHeader.classList.toggle('is-scroll-hidden', scrollingDown);
          lastScrollY = currentScrollY;
        }

        ticking = false;
      };

      const onScroll = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        window.requestAnimationFrame(sync);
      };

      const revealIfNeeded = () => {
        const currentHeader = document.querySelector('.site-header');

        if (currentHeader && isHeaderInteractionOpen()) {
          currentHeader.classList.remove('is-scroll-hidden');
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('click', revealIfNeeded);

      window.AerofoilsHeaderScrollReveal = {
        revealIfNeeded: revealIfNeeded,
        reset: () => {
          lastScrollY = window.scrollY;
        },
        sync: sync,
      };
    }

    header.classList.remove('is-scroll-hidden');
    window.AerofoilsHeaderScrollReveal.reset();
    window.AerofoilsHeaderScrollReveal.sync();
  };

  initHeaderRevealOnScroll();

  if (!window.AerofoilsHeaderScrollRevealSectionLoadBound) {
    document.addEventListener('shopify:section:load', initHeaderRevealOnScroll);
    window.AerofoilsHeaderScrollRevealSectionLoadBound = true;
  }

  if (!customElements.get('localization-form')) {
    /**
     * Dropdown-Verhalten für den Sprachumschalter.
     *
     * Das Umschalten selbst macht Shopify's natives Localization-Form: jede
     * Option ist ein `<button type="submit" name="locale_code">`. Diese Klasse
     * fügt nur das Auf-/Zuklappen und den Submit-on-change des mobilen Selects
     * hinzu — ohne JS bleibt der Umschalter voll funktionsfähig.
     */
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-localization-button]');
        this.panel = this.querySelector('[data-localization-panel]');
        this.nativeSelect = this.querySelector('[data-localization-native-select]');
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleNativeSelectChange = this.handleNativeSelectChange.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
      }

      connectedCallback() {
        if (this.nativeSelect) {
          this.nativeSelect.addEventListener('change', this.handleNativeSelectChange);
        }

        if (!this.button || !this.panel) {
          return;
        }

        this.button.addEventListener('click', this.handleButtonClick);
        document.addEventListener('click', this.handleClickOutside);
        this.addEventListener('keyup', this.handleEscape);
        this.addEventListener('focusout', this.handleFocusOut);
      }

      disconnectedCallback() {
        this.nativeSelect?.removeEventListener('change', this.handleNativeSelectChange);
        this.button?.removeEventListener('click', this.handleButtonClick);
        document.removeEventListener('click', this.handleClickOutside);
        this.removeEventListener('keyup', this.handleEscape);
        this.removeEventListener('focusout', this.handleFocusOut);
      }

      handleButtonClick() {
        this.toggle();
      }

      handleNativeSelectChange(event) {
        event.currentTarget.form?.submit();
      }

      toggle() {
        if (!this.panel) {
          return;
        }

        if (this.panel.hidden) {
          this.open();
        } else {
          this.close();
        }
      }

      open() {
        if (!this.button || !this.panel) {
          return;
        }

        this.button.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
      }

      close() {
        if (!this.button || !this.panel) {
          return;
        }

        this.button.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
      }

      handleClickOutside(event) {
        if (!this.contains(event.target)) {
          this.close();
        }
      }

      handleEscape(event) {
        if (event.key === 'Escape') {
          this.close();
          this.button?.focus();
        }
      }

      handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.close();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  if (!customElements.get('header-search-form')) {
    class HeaderSearchForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.input = this.querySelector('[data-search-input]');
        this.resultsContainer = this.querySelector('[data-search-results]');
        this.searchUrl = this.dataset.searchUrl || '';
        this.loadingLabel = this.dataset.loadingLabel || 'Searching...';
        this.unavailableLabel = this.dataset.unavailableLabel || 'Search is currently unavailable.';
        this.results = [];
        this.activeIndex = -1;
        this.cachedResults = {};
        this.abortController = null;
        this.handleInput = createHeaderDebounce(this.handleInput.bind(this), 180);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        if (!this.form || !this.input || !this.resultsContainer) {
          return;
        }

        this.input.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.input?.removeEventListener('input', this.handleInput);
        this.input?.removeEventListener('keydown', this.handleKeydown);
      }

      async handleInput() {
        const typedQuery = this.input.value.trim();

        if (!typedQuery) {
          this.clearResults();
          return;
        }

        if (!this.searchUrl) {
          this.resultsContainer.innerHTML = '';
          return;
        }

        // Dieser Block ist ein statischer JavaScript-Tag ohne Liquid-Zugriff;
        // theme.liquid setzt <html lang> auf den aktiven Shopify-Locale.
        const currentLanguage = document.documentElement.lang || '';
        const queryKey = `${currentLanguage || 'default'}::${typedQuery
          .toLowerCase()
          .replace(/\s+/g, '-')}`;

        if (this.cachedResults[queryKey]) {
          this.abortController?.abort();
          this.abortController = null;
          this.renderResults(this.cachedResults[queryKey]);
          return;
        }

        this.renderMessage('site-search-drawer__placeholder', this.loadingLabel);

        let controller = null;

        try {
          this.abortController?.abort();
          controller = new AbortController();
          this.abortController = controller;

          const searchParams = new URLSearchParams({
            q: typedQuery,
            section_id: 'helper-predictive-search',
          });

          searchParams.set('options[prefix]', 'last');

          const response = await fetch(
            `${this.searchUrl}?${searchParams.toString()}`,
            { signal: controller.signal },
          );

          if (!response.ok) {
            throw new Error(`Search request failed with ${response.status}`);
          }

          const text = await response.text();
          const html = new DOMParser().parseFromString(text, 'text/html');
          const results = html.querySelector('#shopify-section-helper-predictive-search')?.innerHTML || '';

          if (!results.trim()) {
            throw new Error('Search results markup missing');
          }

          if (typedQuery !== this.input.value.trim()) {
            return;
          }

          this.cachedResults[queryKey] = results;
          this.renderResults(results);
        } catch (error) {
          if (error.name === 'AbortError') {
            return;
          }

          this.renderMessage('site-search-drawer__empty', this.unavailableLabel);
        } finally {
          if (this.abortController === controller) {
            this.abortController = null;
          }
        }
      }

      renderResults(markup) {
        this.resultsContainer.innerHTML = markup;
        this.results = Array.from(this.resultsContainer.querySelectorAll('[data-predictive-search-item]'));
        this.activeIndex = -1;
      }

      renderMessage(className, message) {
        this.resultsContainer.innerHTML = `<p class="${className}"></p>`;
        const element = this.resultsContainer.querySelector(`.${className}`);
        if (element) {
          element.textContent = message;
        }
        this.results = [];
        this.activeIndex = -1;
      }

      clearResults() {
        this.abortController?.abort();
        this.abortController = null;
        this.resultsContainer.innerHTML = '';
        this.results = [];
        this.activeIndex = -1;
      }

      handleKeydown(event) {
        if (!this.results.length) {
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.navigate(1);
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.navigate(-1);
        }

        if (event.key === 'Enter' && this.activeIndex >= 0) {
          event.preventDefault();
          this.results[this.activeIndex].click();
        }
      }

      navigate(step) {
        if (this.activeIndex >= 0) {
          this.results[this.activeIndex].classList.remove('is-active');
        }

        const nextIndex = this.activeIndex + step;
        if (nextIndex < 0) {
          this.activeIndex = -1;
          return;
        }

        this.activeIndex = Math.min(nextIndex, this.results.length - 1);
        const activeResult = this.results[this.activeIndex];
        activeResult.classList.add('is-active');
        activeResult.scrollIntoView({ block: 'nearest' });
      }
    }

    customElements.define('header-search-form', HeaderSearchForm);
  }

  if (!customElements.get('header-mini-cart')) {
    class HeaderMiniCart extends HTMLElement {
      constructor() {
        super();
        this.cartChangeUrl = this.dataset.cartChangeUrl || '';
        this.errorLabel = this.dataset.errorLabel || "We couldn't update your cart. Please try again.";
      }

      connectedCallback() {
        this.bindEvents();
        this.updateHeaderCount();
      }

      bindEvents() {
        this.querySelectorAll('[data-cart-qty-change]').forEach((button) => {
          button.addEventListener('click', (event) => {
            const item = event.currentTarget.closest('[data-cart-item]');
            const input = item?.querySelector('[data-cart-qty-input]');
            const delta = Number(event.currentTarget.dataset.cartQtyChange || 0);
            const nextQuantity = Math.max(0, Number(input?.value || 0) + delta);

            if (item) {
              this.updateLine(item.dataset.line, nextQuantity);
            }
          });
        });

        this.querySelectorAll('[data-cart-qty-input]').forEach((input) => {
          input.addEventListener('change', (event) => {
            const item = event.currentTarget.closest('[data-cart-item]');
            const nextQuantity = Math.max(0, Number(event.currentTarget.value || 0));

            if (item) {
              this.updateLine(item.dataset.line, nextQuantity);
            }
          });
        });

        this.querySelectorAll('[data-cart-remove]').forEach((button) => {
          button.addEventListener('click', (event) => {
            const item = event.currentTarget.closest('[data-cart-item]');
            if (item) {
              this.updateLine(item.dataset.line, 0);
            }
          });
        });
      }

      async updateLine(line, quantity) {
        this.classList.add('is-loading');

        try {
          const response = await fetch(this.cartChangeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              line: Number(line),
              quantity: Number(quantity),
            }),
          });

          const payload = await response.json();
          await this.refresh();

          if (!response.ok || payload.status === 422) {
            throw new Error(payload.description || payload.message || this.errorLabel);
          }
        } catch (error) {
          this.setFeedback(error.message || this.errorLabel);
        } finally {
          this.classList.remove('is-loading');
        }
      }

      async refresh(openDrawer = false) {
        const response = await fetch('?section_id=helper-cart');
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const content = html.querySelector('#shopify-section-helper-cart');

        if (content) {
          this.innerHTML = content.innerHTML;
          this.bindEvents();
          this.updateHeaderCount();
          this.setFeedback('');
        }

        if (openDrawer && window.AerofoilsHeaderDrawers) {
          window.AerofoilsHeaderDrawers.open('cart');
        }
      }

      updateHeaderCount() {
        const count = Number(this.querySelector('.site-cart-drawer__content')?.dataset.cartCount || 0);
        document.querySelectorAll('[data-header-cart-count]').forEach((counter) => {
          counter.textContent = count;
          counter.classList.toggle('is-hidden', count === 0);
        });
      }

      setFeedback(message) {
        const feedback = this.querySelector('[data-cart-feedback]');
        if (!feedback) {
          return;
        }

        if (message) {
          feedback.hidden = false;
          feedback.textContent = message;
        } else {
          feedback.hidden = true;
          feedback.textContent = '';
        }
      }
    }

    customElements.define('header-mini-cart', HeaderMiniCart);
  }

  if (!window.AerofoilsHeaderDrawers) {
    const closeDrawer = () => {
      const activeDrawer = document.querySelector('.site-header-sidebar.is-active');

      if (!activeDrawer) {
        return;
      }

      activeDrawer.classList.remove('is-active');
      document.body.classList.remove('site-header-sidebar-open');
      syncHeaderOverlayState();

      window.setTimeout(() => {
        activeDrawer.hidden = true;
        syncHeaderOverlayState();
      }, 240);
    };

    const openDrawer = (drawerName) => {
      const drawer = document.querySelector(`[data-header-drawer="${drawerName}"]`);

      if (!drawer) {
        return;
      }

      drawer.hidden = false;
      document.body.classList.add('site-header-sidebar-open');
      syncHeaderOverlayState();

      document.querySelectorAll('.site-header__drawer[open]').forEach((menu) => {
        menu.removeAttribute('open');
      });

      window.AerofoilsCloseDesktopMegaMenus?.({ immediate: true });

      document.querySelectorAll('[data-header-drawer]').forEach((sidebar) => {
        if (sidebar !== drawer) {
          sidebar.classList.remove('is-active');
          sidebar.hidden = true;
        }
      });

      requestAnimationFrame(() => {
        drawer.classList.add('is-active');
      });

      if (drawerName === 'search') {
        window.setTimeout(() => {
          drawer.querySelector('[data-search-input]')?.focus();
        }, 80);
      }
    };

    window.AerofoilsHeaderDrawers = {
      open: openDrawer,
      close: closeDrawer,
    };

    const openCartDrawerWithFreshData = () => {
      if (window.AerofoilsCartUI && typeof window.AerofoilsCartUI.refresh === 'function') {
        return window.AerofoilsCartUI.refresh({ openDrawer: true }).catch((error) => {
          console.error('Cart refresh before open failed:', error);
          openDrawer('cart');
        });
      }

      openDrawer('cart');
      return Promise.resolve();
    };

    window.refreshCart = (openDrawerOnRefresh = true) => {
      if (window.AerofoilsCartUI && typeof window.AerofoilsCartUI.refresh === 'function') {
        return window.AerofoilsCartUI.refresh({ openDrawer: openDrawerOnRefresh });
      }

      document.querySelector('[data-mini-cart]')?.refresh(openDrawerOnRefresh);
      return Promise.resolve();
    };

    document.addEventListener('click', (event) => {
      const searchTrigger = event.target.closest('[data-header-search-trigger]');
      const cartTrigger = event.target.closest('[data-header-cart-trigger]');
      const closeTrigger = event.target.closest('[data-header-drawer-close]');
      const overlay = event.target.closest('[data-header-overlay]');

      if (searchTrigger) {
        event.preventDefault();
        openDrawer('search');
      }

      if (cartTrigger) {
        event.preventDefault();
        openCartDrawerWithFreshData();
      }

      if (closeTrigger || overlay) {
        closeDrawer();

        document.querySelectorAll('.site-header__drawer[open]').forEach((menuDrawer) => {
          menuDrawer.aerofoilsCloseMenu?.();
        });

        window.AerofoilsCloseDesktopMegaMenus?.();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  }

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-custom-cart-change]');

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const line = Number(button.dataset.line);
  const quantity = Math.max(0, Number(button.dataset.quantity));
  const panel = button.closest('.custom-cart-panel');
  const item = button.closest('.custom-cart-item');
  const itemKey = item?.dataset.itemKey || '';
  const isRemoval = quantity === 0;

  if (!panel || panel.classList.contains('is-updating')) {
    return;
  }

  panel.classList.add('is-updating');
  if (item) {
    item.classList.add(isRemoval ? 'is-pending-removal' : 'is-loading');
  }

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity
      })
    });

    const cart = await response.json();

    if (!response.ok) {
      throw new Error(cart.description || 'Cart update failed');
    }

    if (isRemoval && item) {
      item.classList.remove('is-loading', 'is-pending-removal');
      item.classList.add('is-removing');
      await new Promise((resolve) => window.setTimeout(resolve, 180));
    }

    if (window.AerofoilsCartUI) {
      const updateOptions = {
        highlightKey: isRemoval ? '' : itemKey,
      };

      if (typeof window.AerofoilsCartUI.refresh === 'function') {
        await window.AerofoilsCartUI.refresh(updateOptions);
      } else if (typeof window.AerofoilsCartUI.update === 'function') {
        window.AerofoilsCartUI.update(cart, updateOptions);
      }
    }
  } catch (error) {
    item?.classList.remove('is-loading', 'is-pending-removal', 'is-removing');
    console.error('Custom cart update error:', error);
  } finally {
    panel.classList.remove('is-updating');
  }
}, true);

if (!window.AerofoilsAjaxAddToCartReady) {
  window.AerofoilsAjaxAddToCartReady = true;

  const customCartFormatMoney = (cents) => {
    const amount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);

    return customCartMoneySample.replace(/[\d,.]+/, amount);
  };

  const customCartEscape = (value = '') => {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  };

  const cartLabels = () => window.AerofoilsCartLabels || {};

  const cartLabel = (key, title = '') => {
    const value = cartLabels()[key];
    if (typeof value !== 'string') {
      return '';
    }
    return value.replaceAll('%%TITLE%%', () => title);
  };

  const customCartTrashIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3.33203 5.83333H16.6654" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.33203 9.16667V14.1667" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.668 9.16667V14.1667" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.16797 5.83333L5.0013 15.8333C5.0013 16.2754 5.1769 16.6993 5.48946 17.0118C5.80202 17.3244 6.22594 17.5 6.66797 17.5H13.3346C13.7767 17.5 14.2006 17.3244 14.5131 17.0118C14.8257 16.6993 15.0013 16.2754 15.0013 15.8333L15.8346 5.83333" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const customCartMinusIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M4.16797 10H15.8346" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const customCartPlusIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 4.16666V15.8333" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.16797 10H15.8346" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const customCartCloseIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M15 5L5 15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 5L15 15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const customCartBackIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M4.16797 10H15.8346" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.16797 10L7.5013 13.3333" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.16797 10L7.5013 6.66669" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const updateCustomHeaderCartCount = (cart) => {
    document.querySelectorAll('[data-header-cart-count]').forEach((counter) => {
      counter.textContent = cart.item_count;
      counter.classList.toggle('is-hidden', cart.item_count === 0);
    });
  };

  const shouldHideCustomCartItem = (item = {}) => {
    const quantity = Number(item.quantity || 0);
    const title = String(item.product_title || item.title || '').toLowerCase();
    const finalLinePrice = Number(item.final_line_price || 0);

    if (quantity <= 0) {
      return true;
    }

    return title.includes('(parent)') && finalLinePrice === 0;
  };

  const getVisibleCustomCartItems = (cart) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];

    return items.reduce((result, item, index) => {
      if (shouldHideCustomCartItem(item)) {
        return result;
      }

      result.push({
        ...item,
        __line: index + 1,
      });

      return result;
    }, []);
  };

  const renderCustomCartDrawer = (cart, options = {}) => {
    const panel = document.querySelector('[data-header-drawer="cart"] .custom-cart-panel');

    if (!panel) return;

    const visibleItems = getVisibleCustomCartItems(cart);

    const itemsMarkup = visibleItems.map((item) => {
      const line = item.__line;
      const itemKey = item.key || '';
      const bundleDisplay = item.properties && item.properties._aerofoils_display
        ? String(item.properties._aerofoils_display)
        : '';
      const addonParent = item.properties && item.properties._aerofoils_addon_parent
        ? String(item.properties._aerofoils_addon_parent)
        : '';
      const addonGroup = item.properties && item.properties._aerofoils_addon_group
        ? String(item.properties._aerofoils_addon_group)
        : '';
      const addonOption = item.properties && item.properties._aerofoils_addon_option
        ? String(item.properties._aerofoils_addon_option)
        : '';
      const addonSize = item.properties && item.properties._aerofoils_addon_size
        ? String(item.properties._aerofoils_addon_size)
        : '';
      const isBundleParent = !!(bundleDisplay || (item.properties && item.properties._aerofoils_config));
      const isBundleAddon = !!addonParent;
      const image = item.image
        ? `<img src="${customCartEscape(item.image)}" alt="${customCartEscape(item.product_title)}" loading="lazy" class="custom-cart-product-img">`
        : '';

      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="custom-cart-options"><span>${customCartEscape(item.variant_title)}</span></div>`
        : '';

      const propertiesMarkup = item.properties
        ? Object.entries(item.properties)
          .filter(([key, value]) => value && !String(key).startsWith('_'))
          .map(([, value]) => `<span>${customCartEscape(value)}</span>`)
          .join('')
        : '';
      const bundleMeta = isBundleParent && bundleDisplay
        ? `<div class="custom-cart-options"><span>${customCartEscape(bundleDisplay)}</span></div>`
        : isBundleAddon
          ? `<div class="custom-cart-options"><span>${customCartEscape(addonGroup || cartLabel('addon'))}: ${customCartEscape(addonOption || item.product_title)}${addonSize ? ` · ${customCartEscape(addonSize)}` : ''}</span></div>`
          : '';

      const itemClasses = ['custom-cart-item'];
      if (options.highlightKey && itemKey === options.highlightKey) {
        itemClasses.push('is-highlighted');
      }

      return `
        <div class="${itemClasses.join(' ')}" data-item-key="${customCartEscape(itemKey)}">
          <div class="custom-cart-image">
            ${image}
          </div>

          <div class="custom-cart-info">
            <div class="custom-cart-top">
              <a href="${customCartEscape(item.url)}" class="custom-cart-title">
                ${customCartEscape(item.product_title)}
              </a>

              <button
                type="button"
                class="custom-cart-remove"
                aria-label="${customCartEscape(cartLabel('removeItem', item.product_title))}"
                data-custom-cart-change
                data-line="${line}"
                data-quantity="0"
              >
                ${customCartTrashIcon}
              </button>
            </div>

            ${variantTitle}
            ${bundleMeta}
            ${propertiesMarkup ? `<div class="custom-cart-options">${propertiesMarkup}</div>` : ''}

            <div class="custom-cart-bottom">
              <div class="custom-cart-price">
                ${customCartFormatMoney(item.final_line_price, cart.currency)}
              </div>

              <div class="custom-cart-qty">
                <button
                  type="button"
                  class="custom-cart-qty-btn"
                  data-custom-cart-change
                  data-line="${line}"
                  data-quantity="${Math.max(0, item.quantity - 1)}"
                  aria-label="${customCartEscape(cartLabel('decreaseQuantity'))}"
                  ${isBundleParent ? 'disabled' : ''}
                >
                  ${customCartMinusIcon}
                </button>

                <input type="number" name="updates[]" value="${item.quantity}" min="0" aria-label="${customCartEscape(cartLabel('quantityFor', item.product_title))}" ${isBundleParent ? 'readonly disabled' : ''}>

                <button
                  type="button"
                  class="custom-cart-qty-btn"
                  data-custom-cart-change
                  data-line="${line}"
                  data-quantity="${item.quantity + 1}"
                  aria-label="${customCartEscape(cartLabel('increaseQuantity'))}"
                  ${isBundleParent ? 'disabled' : ''}
                >
                  ${customCartPlusIcon}
                </button>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');

    // Regional sales restriction (dealer / inquiry): keep the info box and
    // hide the checkout button when a rule applies (server-side country match
    // or province match resolved by assets/region-sales.js).
    const regionSalesRoot = panel.closest('[data-region-sales-section]');
    const regionSalesTemplate = regionSalesRoot
      ? regionSalesRoot.querySelector('[data-region-sales-cart-notice-template]')
      : null;
    const regionSalesNoticeMarkup = regionSalesTemplate ? regionSalesTemplate.innerHTML : '';
    const regionSalesActive = !!regionSalesRoot
      && (regionSalesRoot.dataset.regionSalesActive === 'true' || !!regionSalesRoot.dataset.regionSalesActiveRule);
    const regionSalesCheckoutMarkup = regionSalesActive
      ? ''
      : `
                  ${regionSalesRoot ? '<div class="region-sales-default" data-region-sales-default>' : ''}
                  <button type="submit" name="checkout" class="custom-cart-checkout">
                    ${customCartEscape(cartLabel('checkout'))}
                  </button>
                  ${regionSalesRoot ? '</div>' : ''}
                `;

    panel.innerHTML = `
      <div class="custom-cart-header">
        <h2>${customCartEscape(cartLabel('title'))}</h2>

        <button class="custom-cart-close" type="button" aria-label="${customCartEscape(cartLabel('close'))}" data-header-drawer-close>
          ${customCartCloseIcon}
        </button>
      </div>

      ${
        visibleItems.length > 0
          ? `
            <form action="/cart" method="post" novalidate class="custom-cart-form">
              <div class="custom-cart-items">
                ${itemsMarkup}
              </div>

              ${regionSalesNoticeMarkup}

              <div class="custom-cart-footer">
                <div class="custom-cart-total">
                  <span>${customCartEscape(cartLabel('total'))}</span>
                  <strong>${customCartFormatMoney(cart.total_price, cart.currency)}</strong>
                </div>

                <div class="custom-cart-actions">
                  ${regionSalesCheckoutMarkup}
                </div>
              </div>
            </form>
          `
          : `
            <div class="custom-cart-empty">
              <p>${customCartEscape(cartLabel('empty'))}</p>
              <a href="/collections/all" class="custom-cart-checkout">
                ${customCartEscape(cartLabel('backToCatalogue'))}
              </a>
            </div>
          `
      }
    `;
  };

  window.AerofoilsCartUI = {
    update(cart, options = {}) {
      if (!cart) return;

      updateCustomHeaderCartCount(cart);
      renderCustomCartDrawer(cart, options);

      if (options.openDrawer && window.AerofoilsHeaderDrawers) {
        window.AerofoilsHeaderDrawers.open('cart');
      }
    },

    async refresh(options = {}) {
      const cartResponse = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });
      const cart = await cartResponse.json();

      window.AerofoilsCartUI.update(cart, options);

      return cart;
    }
  };

  const getAddToCartButtons = (form, submitter = null) => {
    const buttons = new Set();

    const maybeAddButton = (button) => {
      if (!button || typeof button.matches !== 'function') {
        return;
      }

      if (!button.matches('button[type="submit"], input[type="submit"]')) {
        return;
      }

      buttons.add(button);
    };

    maybeAddButton(submitter);
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(maybeAddButton);

    const formId = form.getAttribute('id');
    if (formId) {
      const escapedFormId = window.CSS && typeof window.CSS.escape === 'function'
        ? window.CSS.escape(formId)
        : formId.replace(/"/g, '\\"');

      document
        .querySelectorAll(`button[type="submit"][form="${escapedFormId}"], input[type="submit"][form="${escapedFormId}"]`)
        .forEach(maybeAddButton);
    }

    return Array.from(buttons);
  };

  const setAddToCartButtonsState = (buttons, state) => {
    buttons.forEach((button) => {
      if (button.dataset.wasDisabledBeforeSubmit == null) {
        button.dataset.wasDisabledBeforeSubmit = button.disabled ? 'true' : 'false';
      }

      const labelNode = button.querySelector('[data-product-submit-label]');

      if (state === 'loading') {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.classList.remove('is-added');
        button.classList.add('is-loading');

        if (labelNode && button.dataset.addToCartLoadingLabel) {
          labelNode.textContent = button.dataset.addToCartLoadingLabel;
        }

        return;
      }

      if (state === 'success') {
        button.disabled = true;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.classList.add('is-added');

        if (labelNode && button.dataset.addToCartSuccessLabel) {
          labelNode.textContent = button.dataset.addToCartSuccessLabel;
        }

        return;
      }

      const wasDisabledBeforeSubmit = button.dataset.wasDisabledBeforeSubmit === 'true';
      button.disabled = wasDisabledBeforeSubmit;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading', 'is-added');

      if (labelNode && button.dataset.addToCartDefaultLabel) {
        labelNode.textContent = button.dataset.addToCartDefaultLabel;
      }

      delete button.dataset.wasDisabledBeforeSubmit;
    });
  };

  const pulseHeaderCartTrigger = () => {
    document.querySelectorAll('[data-header-cart-trigger]').forEach((trigger) => {
      trigger.classList.remove('is-bumping');
      void trigger.offsetWidth;
      trigger.classList.add('is-bumping');

      window.setTimeout(() => {
        trigger.classList.remove('is-bumping');
      }, 520);
    });
  };

  window.AerofoilsCartUI.setAddToCartButtonsState = setAddToCartButtonsState;
  window.AerofoilsCartUI.pulseHeaderCartTrigger = pulseHeaderCartTrigger;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');

    if (!form) return;
    if (form.dataset.aerofoilsBundleAddons === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    const submitButtons = getAddToCartButtons(form, event.submitter || null);
    setAddToCartButtonsState(submitButtons, 'loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json'
        }
      });

      const payload = await response.json();

      if (!response.ok) {
        throw new Error(payload.description || payload.message || 'Add to cart failed');
      }

      await window.AerofoilsCartUI.refresh({ openDrawer: true });
      pulseHeaderCartTrigger();
      setAddToCartButtonsState(submitButtons, 'success');
      await new Promise((resolve) => window.setTimeout(resolve, 1200));
    } catch (error) {
      console.error('Add to cart error:', error);
    } finally {
      setAddToCartButtonsState(submitButtons, 'default');
    }
  }, true);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thank-you-redirect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRedirect(root) {
      if (root.dataset.tyrInit === 'true') return;
      root.dataset.tyrInit = 'true';

      var target = root.getAttribute('data-tyr-target');
      var delay = parseInt(root.getAttribute('data-tyr-delay'), 10);
      if (isNaN(delay) || delay < 0) delay = 3;

      // Defensiv: nur absolute https-URLs oder interne (relative) Pfade zulassen.
      if (!target || !/^(https:\/\/|\/)/i.test(target)) return;

      // --- Optionaler Tracking-Hook -------------------------------------
      // Hier kann später ein Conversion-/Lead-Event gefeuert werden, z. B.:
      //   var pageTitle = root.getAttribute('data-tyr-page-title');
      //   window.dataLayer && window.dataLayer.push({ event: 'generate_lead', content_name: pageTitle });
      //   window.fbq && fbq('track', 'Lead', { content_name: pageTitle });
      // Aktuell bewusst NICHT scharf geschaltet – nur Platzhalter.
      // ------------------------------------------------------------------

      var redirect = function () {
        // 'replace' statt 'assign': Zwischenseite landet nicht im Back-Verlauf.
        window.location.replace(target);
      };

      if (delay === 0) {
        redirect();
        return;
      }

      var textEl = root.querySelector('[data-tyr-countdown-text]');
      // Rohe Textvorlage mit {seconds}-Platzhalter, damit sie pro Tick ersetzt werden kann.
      var placeholderTemplate = root.getAttribute('data-tyr-text-template');

      var remaining = delay;

      var tick = function () {
        remaining -= 1;
        if (remaining < 0) remaining = 0;
        if (textEl && placeholderTemplate) {
          textEl.textContent = placeholderTemplate.replace('{seconds}', String(remaining));
        }
      };

      var interval = setInterval(function () {
        tick();
        if (remaining <= 0) {
          clearInterval(interval);
        }
      }, 1000);

      setTimeout(function () {
        clearInterval(interval);
        redirect();
      }, delay * 1000);
    }

    function boot() {
      var roots = document.querySelectorAll('[data-tyr]');
      for (var i = 0; i < roots.length; i++) {
        initRedirect(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
